// TODO: проверить
import { API, Competition, CompetitionAPI, Designer, DocumentAPI, Endpoints, Lang, Project, Tag } from "@brg/api";
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { ProfileRole, bProfile, useProfile } from "@brg/auth";
import { Input } from "@brg/input";
import {Colors, CommonInput, DropdownListItem, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile, useToasts} from "@brg/ui";
import { useSimpleUploader } from "@brg/uploader";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {bArray, bTag, LayoutConst, useModal} from "core";
import { BTag } from "core/components";
import { bColor } from "core/utils/bColor";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import {ReactComponent as DottedIcon } from 'shared/pages/teams/handle.svg';
import { ProjectEditFrameError, ProjectEditFrameForbidden, ProjectEditFrameUpdateError } from "shared/components/error-frames";
import { NavbarCreate } from "shared/components/navbar-elements";
import { PageViewportLayout, ProjectContainerLayout } from "shared/components/template";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { ScrollUpZone } from "shared/components/__FOX__/NAV/src/scroll-up-zone";
import { CreateLinkTo } from "shared/constants/linkTo";
import { createThemeByColor } from "shared/helpers/coloring";
import ColorPicker, { WIDE_SCREEN_COLORS } from "shared/pages/projectEdit/components/ColorPicker/ColorPicker";
import LeftSide from "shared/pages/projectEdit/LeftSide";
import LongReadBlock from "shared/pages/projectEdit/LongReadBlock";
import ProjectAuthorsEdit, { ProjectAuthorsChangeCbT } from "shared/pages/projectEdit/ProjectAuthorsEdit";
import ProjectTitleSection from "shared/pages/projectEdit/ProjectTitleSection";
import { GlobalColoring, ProjectAuthorsWrapper, ProjectEditPageContainer, ProjectEditPageGrid, ProjectEditPageGridLabel, ProjectEditPageGridRow, ProjectEditPageGridStartLabel } from "shared/pages/projectEdit/styles";
import { AuthorT, LongreadMobileActions } from "shared/pages/projectEdit/types";
import { convertDesignerFromGlobalToLocal } from "shared/pages/projectEdit/utils";
import { setType } from "shared/reducers/ViewTypeSlice";
import styled, {css, ThemeProvider, useTheme} from "styled-components";
import { STATUSES, STATUSES_List } from "_competition/const";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { ShortListProjectsEdit } from "./Components/ShortListProjects/ShortListProjectsEdit";
import { Counter, CriteriaWrapper, SortableWrapper } from "./styles";
import { Date24Icon } from "shared/components/tagAdminProjectsSearchBar/date24";
import { Date32Icon } from "shared/components/tagAdminProjectsSearchBar/date32";
import 'shared/components/tagAdminProjectsSearchBar/styles.css';
import DateTimePicker from "react-datetime-picker";
import {CustomBgWrapper} from "../../../shared/components/CustomBgWrapper/CustomBgWrapper";
import PlusIconThin from "../../../shared/icons/PlusIconThin";
import { ShortListWinnerProjectsEdit } from "./Components/ShortListProjects/ShortListWinnerProjectsEdit";
import { DefaultButton, TableSortWrapper } from "../../../shared/pages/teams/styles";
import { allowedCharacters, allowedMaxCount, setTextByLang } from "../../../shared/pages/teams/TeamEdit";
import { BasketIcon } from "../../../shared/pages/projectEdit/BasketIcon";
import { CompetitionEditFrameCreating, CompetitionEditFrameLoading } from "shared/components/error-frames/competition-edit-frames";
import { LangTitleBox } from "shared/components/LangTitleBox/LangTitleBox";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { computeDataWithLang } from "shared/helpers/types/computed/ComputedTeam";
import {ReactComponent as PlusSvg } from "shared/pages/projectEdit/close.svg";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import { slicedKey } from "shared/actions/infinityProjectsActions";
import { useToggleBilingual } from "shared/hooks/useToggleBilingual";
import { ContextsSection } from "./sections/ContextsSections/ContextsSection";
import { BilingualSwitcher } from "shared/components/BilingualSwitcher/BilingualSwitcher";
import { HsePolicies } from "shared/constants/HsePolicies";
import { COMPETITIONS_CONTEXTS } from "../AllCompetitionsPage/const/competitionContexts";
import { FABRIC_FLOW, fabricFlowOpts } from "shared/pages/DesignFabric/components/FlowDropdown";
import {ExamPageEdit} from "../../../shared/pages/examPage/examPageEdit";
import {ButtonFilled, LabelRedStar} from "../../../shared/pages/designerEditView/styles";
import { CUSTOMTABS } from "shared/pages/opencallsPage/GetCompetitionItem/GetCompetitionItem";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { Criteria } from "@brg/api/dist/api-core/classes/CompetitionAPI";
import { Voidable } from "@brg/toolbox";
import { CompetitionCertificatesBlock } from "./Components/CompetitionCertificatesBlock";
import CloseIconSmall from "shared/icons/CloseIconSmall";

const MIN_CRITERIA_COUNT = 5;
const MAX_CRITERIA_COUNT = 10;
const DEFAULT_PARTICIPANTS_COUNT = 0;
const MAX_PARTICIPANTS_COUNT = 1000;

const COMPETITION_LINK_REG = /^https?:\/\/.+$/;
interface ICompetitionEditPageProps {
  className?: any;
}

const CompetitionEditPageGridRow = styled(ProjectEditPageGridRow)<{isChoose?: boolean, largeOffsets?: boolean, isWinners?: boolean, largeOffset?: boolean, isLMS?: boolean}>`
  margin-top: ${({ largeOffsets }) => largeOffsets ? '32px' : '24px'} !important;
  // align-items: center;

  // .react-datetime-picker__inputGroup__leadingZero, .react-datetime-picker__inputGroup__divider {
  //   color: #151514;
  // }

  ${DropdownListItem} {
  
  }

  .brg-input__indicators {
    justify-content: center;
    display: flex;
    height: 48px;
    max-height: 48px;
    .brg-input__indicator {
      padding: 0;
      height: 40px;
      max-height: 40px;
  
      svg {
        padding: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: ${({ largeOffsets }) => largeOffsets ? '24px' : '16px'};

    input {
      height: 40px !important;
    }

    .brg-input__indicators {
      height: 40px;
      max-height: 40px;
      .brg-input__indicator {
        height: 40px;
        max-height: 40px;
      }
    }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: ${({ largeOffset }) => largeOffset ? '32.2px' : '24px' } !important;
    flex-direction: ${({isCheckbox, isChoose}) => isChoose ? 'row' : isCheckbox ? 'row-reverse' : 'column'};
    align-items: ${({isCheckbox, isChoose}) => (isCheckbox || isChoose) ? 'center' : 'flex-start'};
    justify-content: ${({isCheckbox}) => isCheckbox ? 'flex-end' : 'flex-start'};
    row-gap: 8px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 16px!important;
    flex-direction: ${({isCheckbox}) => isCheckbox ? 'row-reverse' : 'column'};
    align-items: ${({isCheckbox}) => isCheckbox ? 'center' : 'flex-start'};

  }
`;


export const CompetitionFixedBlock = styled(CompetitionEditPageGridRow)<{ disableOffset?: boolean }>`
  max-width: ${LayoutConst.projectCover.l.w}px;

  ${({ disableOffset }) => disableOffset && css`
    margin-top: 0 !important;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: ${LayoutConst.projectCover.m.w}px;
  }
`;

export const CriteriaMaxValueLabel = styled(FlexBox)`
  font-size: 15px;
  line-height: 20xp;
  color: #909090;
`;

export const CompetitionEditPageGridLabel = styled(ProjectEditPageGridLabel)<{isAuthorSelect?: boolean, fullSize?: boolean, isLMS?: boolean, nowrap?: boolean}>`
  margin-right: 24px;
  width: 224px;
  min-width: 224px;
  padding-top: 0;
  color: ${({ theme }) => theme.competition.label.color};

  ${({ nowrap }) => nowrap && css` white-space: nowrap`};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-right: 16px;
    width: 160px;
    min-width: 160px;
    ${({ isLMS }) => isLMS ? css`
      max-width: 160px;
      font-size: 13px;
      line-height: 16px;
    ` : null};

  ${({ fullSize }) => fullSize && css`
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
      min-width: none;
    }
  `}

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: ${({isAuthorSelect}) => isAuthorSelect ? 8 : 0}px;
  }

`
const CompetitionEditPageGridStartLabel = styled(ProjectEditPageGridStartLabel)<{isLMS?: boolean}>`
  margin-right: 0;
  padding-top: 0;
  width: 100%;
  height: 48px;
  margin-bottom: ${({isLMS}) => isLMS ? 0 : 8}px;

  .date-input {
    width: 100%!important;
    max-width: 100% !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%
  }
`

const ButtonText = styled.div`
  color: ${({theme}) => theme.competition.input.secondText};
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  letter-spacing: -0.02em;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const AddTagsWrapper = styled(FlexBox)<{isEmpty?: boolean}>`
  width: 100%;
  height: 32px;
  border: 1px solid ${({theme}) => theme.competition.input.checkbox.border};
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  column-gap: 12px;
  margin-bottom: ${({isEmpty}) => isEmpty ? '0' : '24px'};
  
  svg {
    width: 15px;
    height: 15px;
    path {
      fill: ${({theme}) => theme.competition.input.inputText};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-bottom: ${({isEmpty}) => isEmpty ? '0' : '16px'};
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 16px);
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
  }
`

export const CompetitionContentAddContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  .tags-wrapper-grid-block {
    max-width: 100%;
    margin-top: 16px;
    margin-left: 0;

    * {
      margin-left: 0;
    }
  }
`

const CompetitionEditPageGrid = styled(ProjectEditPageGrid)`
  width: ${LayoutConst.projectContainer.l}px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${LayoutConst.projectContainer.m}px;
    margin-top: 8px;
  }
  
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 32px);
    margin: 0px 16px 0px;
    height: auto;
  }
  
  @media (max-width: ${LayoutConst.screen.s -1}px) {
    width: 100%;
    margin: 0;
  }
`

const CompetitionEditPageContainer = styled(ProjectEditPageContainer)`


  @media (max-width: ${LayoutConst.screen.md}px) {
    padding: 0;
    margin: 0;
  }

  input, .brg-input__control, .competition-select__control {
    height: 48px !important;
    max-height: 48px !important;
    min-height: 48px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 40px !important;
      max-height: 40px !important;
      min-height: 40px !important;

      .brg-input__indicator, .brg-input__dropdown-indicator {
        padding: 0;
      }
    }
  }

  .competition-select__value-container {
    height: 100%:
  }

  .bilingual-container {

    @media (max-width: ${LayoutConst.screen.s -1}px) {
      flex-flow: column;
    }
  }
`

const CompetitionEditPageGridInput = styled(ProjectEditPageGridInput)<{isChoose?: boolean, isLMS?: boolean, isCheck?: boolean}>`
  .competition-select__input {
    display: none !important;
  }
  
  .brg-input__control {
    background-color: ${({theme}) => theme.competition.input.bg} !important;
    border: 1px solid ${({theme}) => theme.competition.input.bg} !important;
    cursor: pointer;

    .brg-input__single-value, .brg-input__placeholder,
    .brg-input__placeholder:hover, .brg-input__single-value:hover {
      color: ${({theme}) => theme.competition.input.inputText} !important;
      border: 1px solid ${({theme}) => theme.competition.input.bg} !important;
    }
    ${({isLMS}) => isLMS && css`
     .brg-input__single-value, .brg-input__placeholder,
      .brg-input__placeholder:hover, .brg-input__single-value:hover {
        color: ${({theme}) => theme.competition.input.mainText} !important;
    }

  `}

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }
  }

  .brg-input__menu-list {
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({theme}) => theme.competition.input.inputText} !important;
    }
  }

  .brg-input__menu {
    background-color: ${({theme}) => theme.competition.input.bg} !important;

    .brg-input__option {
      cursor: pointer;
      color: ${({theme}) => theme.competition.input.inputText} !important;
      svg {
        path {
          fill: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    }
    .brg-input__option--is-focused {
      background-color: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    .brg-input__option--is-focused:hover {
      background-color: ${({theme}) => theme.competition.input.bgActive} !important;
    }
  }
  
  .brg-input__indicator {
    margin-right: 0;
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.inputText} !important;;
      }
    }
  }

  button {
    border: 1px solid ${({theme}) => theme.competition.input.button.border};
    background-color: ${({theme}) => theme.competition.input.button.bg};
    color: ${({theme}) => theme.competition.input.mainText};
    border-radius: 3px;
    padding: 8px 36px;
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
    }
  }

  .globalTypes {
    color: ${({theme}) => theme.competition.input.mainText} !important;
  }

 .competition-select__control {
   background-color: ${({theme}) => theme.competition.input.bg};
   border: none;
   border-radius: 3px;
   cursor: pointer;
   height: 48px;

   @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
     height: 40px;
   }
 }
 .competition-select__menu-list {
   background-color: ${({theme}) => theme.competition.input.bg}!important;
   color: ${({theme}) => theme.competition.input.inputText}!important;
 }
 .competition-select__menu {
   background-color: ${({theme}) => theme.competition.input.bg}!important;
   color: ${({theme}) => theme.competition.input.inputText}!important;
 }
 .competition-select__option {
   background-color: ${({theme}) => theme.competition.input.bg}!important;
   color: ${({theme}) => theme.competition.input.inputText}!important;
   cursor: pointer!important;
 }
  .competition-select__indicator-separator {
    display: none;
  }
  .competition-select__value-container {
    padding: 2px 16px;
    height: 100%;
  }
  .competition-select__indicator {
    align-items: center;
    width: 40px;
    height: 40px;
    color: ${({theme}) => theme.competition.secondaryText} !important;
  }
  
  input ~ .competition-checkbox {
    
    width: 24px;
    height: 24px;
    background: ${({theme}) => theme.competition.input.checkbox.bg} !important;
    border-color: ${({theme}) => theme.competition.input.checkbox.border} !important;
    
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.checkbox.icon};
      }
    }
  }
  
  input.competition-checkbox {
    
    width: 24px!important;
    height: 24px!important;
  }
  
  ${({isCheckbox}) => isCheckbox && css`
    width: fit-content;
  `}

  ${({isCheck}) => isCheck && css`
    align-items: flex-start;
    margin-top: 7px;
  `}
`

export const CustomDateTimePicker = styled(DateTimePicker)<{isLMS?: boolean, isFormPage?: boolean}>`

  .react-calendar {
    background: ${({theme}) => theme.competition.input.bg};
    border: none;
    .react-calendar__tile--now {
      background-color: ${({theme}) => theme.competition.input.date.bgNow} !important;
      color: ${({theme}) => theme.competition.input.date.colorNow} !important;
    }
    .react-calendar__tile--active {
      background-color: ${({theme}) => theme.competition.input.date.bgActive} !important;
      color: ${({theme}) => theme.competition.input.date.colorActive} !important;
    }
  }

  .react-calendar__year-view {
    .react-calendar__year-view__months__month {
      color: ${({ theme }) => theme.competition.secondaryText} !important;
    }
  }

  .react-datetime-picker__inputGroup {


    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute,
    .react-datetime-picker__inputGroup__second {
      outline: none;
      color: ${({theme}) => {
        return theme.competition.secondaryText}} !important;
    }
    ${({isLMS}) => isLMS && css`
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute {
      color: #151514 !important;
    }
  `}
    ${({isFormPage}) => isFormPage && css`
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute {
      color: #151514 !important;
      font-size: 13px !important;
      line-height: 16px !important;
    }
  `}

  }
  
  .react-datetime-picker__inputGroup__input {
    color: ${({theme}) => theme.competition.secondaryText} !important;
  }

  .react-datetime-picker__wrapper {
    border: none;
    border-radius: 3px;
    padding: 0 16px;
    background-color: ${({theme}) => theme.competition.input.bg};
    
    svg {
      path {
        
        fill: ${({theme}) => theme.competition.secondaryText};
      }
    }
  }
`
const ExamMoscowTime = styled.div`
  font-size: 12px;
`
interface Language {
  lang: string;
  name: string;
}

interface Tab {
  name: Language[];     
  position: number;       
  enable: boolean;        
  currentLang: string; 
  tabId: string;   
}
const DEFAULTTABS: Tab[] = [
  {
    name: [{ lang: 'en', name: 'About Competition' }, { lang: 'ru', name: 'О конкурсе' }],
    position: 1,
    enable: false,
    currentLang: "ru",
    tabId: '1'

  },
  {
    name: [{ lang: 'en', name: 'Jury' }, { lang: 'ru', name: 'Жюри' }],
    position: 2,
    enable: false,
    currentLang: "ru",
    tabId: '2' 
  },
  {
    name: [{ lang: 'en', name: 'Projects' }, { lang: 'ru', name: 'Проекты' }],
    position: 3,
    enable: false,
    currentLang: "ru",
    tabId: '3' 
  },
  {
    name: [{ lang: 'en', name: 'Shortlist' }, { lang: 'ru', name: 'Шорт-лист' }],
    position: 4,
    enable: false,
    currentLang: "ru",
    tabId: '4' 
  }
];
const defaultCompetitionName = [
  {
      lang: "Ru",
      name: ""
  },
  {
      lang: "En",
      name: ""
  }
]


const fixTimezoneOffsetToShow = (date: Date | undefined) : Date | undefined => {
  if(!date) return undefined;
  return new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
}
const fixTimezoneLMSExamShow = (date: Date | undefined): Date | undefined => {
  if (!date) return undefined;

  const localDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
  const mskOffset = 3 * 60 * 60 * 1000;
  return new Date(localDate.getTime() + mskOffset);
};

const fixTimezoneOffsetToSave = (date: Date | undefined) : Date | undefined => {
  if(!date) return undefined;
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
}
const fixTimezoneLMSExam = (date: Date | undefined): Date | undefined => {
  if (!date) return undefined;

  const mskOffset = 3 * 60 * 60 * 1000; 
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000) - mskOffset);
};

const TagsWrapper: FC<{children: JSX.Element[], isExam: any}> = ({children, isExam}) => {

  if (isExam) return <CompetitionEditPageGridRow largeOffsets align="flex-start">{children}</CompetitionEditPageGridRow>

  return <CompetitionFixedBlock align="flex-start" className={'tags-wrapper'}>{children}</CompetitionFixedBlock>

}

const setCompetitionStringValueByLang = (
  isBilingual: boolean,
  currentValue: LangObject[],
  lang: string,
  value: string
): LangObject[] => {
  if (isBilingual) {
    const engValue = currentValue.find(({ lang }) => lang.toLowerCase() === 'en')!
    const ruValue = currentValue.find(({ lang }) => lang.toLowerCase() === 'ru')!
    if (lang.toLowerCase() === 'ru') {
      return [{
        lang: 'ru',
        name: value,
      }, engValue];
    } else {
      return [ruValue, {
        lang: 'en',
        name: value,
      }]
    }
  } else {
    return createDefaultLangObject(value);
  }
}

const CreateCompetitionPage: FC<ICompetitionEditPageProps> = ({ className }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const toasts = useToasts();
  const profile = useProfile();
  const isMobile = useIsMobile();
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const history = useHistory();
  const theme = useTheme();
  const modal = useModal();
  const { id } = useParams<{ id: string }>();
  const competitionIdRef = useRef<any>(null);
  const langRef = useRef<any>(null);
  const bilingualRef = useRef<any>(null);
  const sipRef = useRef<any>(null);
  const sipRefEn = useRef<any>(null);
  const throttle = useRef<any>();
  const [time, setTime] = useState(Date.now());
  const [isCreating, setIsCreating] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isForbidden, setIsForbidden] = useState(false);
  const [isUpdateError, setIsUpdateError] = useState(false);
  const [competition, setCompetition] = useState<Competition<'Global'> | undefined>();
  const [competitionName, setCompetitionName] = useState<LangObject[]>(defaultCompetitionName);
  const [competitionAdministrators, setCompetitionAdministrators] = useState<AuthorT[]>([]);
  const [competitionModerators, setCompetitionModerators] = useState<Designer<'Local'>[]>([]);
  const [competitionJury, setCompetitionJury] = useState<Designer<'Local'>[]>([]);
  const [competitionJuryText, setCompetitionJuryText] = useState<LangObject[]>([]);
  const [competitionVisibility, setCompetitionVisibility] = useState<boolean>(false);
  const [competitionIgnoreProjectShowcase, setCompetitionIgnoreProjectShowcase] = useState<boolean>(false);
  const [competitionStatus, setCompetitionStatus] = useState<{ label: string; value: number; }>();
  const [competitionContexts, setCompetitionContexts] = useState<string[]>([]);
  const [competitionLink, setCompetitionLink] = useState<string>('');
  const [competitionContextText, setCompetitionContextText] = useState<string>('');
  const [editContextText, setEditContextText] = useState<string>('');
  const [competitionCreativeOpen, setCompetitionCreativeOpen] = useState<boolean>(false);
  const [winnerIntroText, setWinnerIntroText ] = useState<LangObject[]>([]);
  const [winnerFinalText, setWinnerFinalText] = useState<LangObject[]>([]);
  const [enrollButtonText, setEnrollButtonText] = useState<LangObject[]>([]);

  const [criteriaList, setCriteriaList] = useState<Criteria[]>([]);

  const isExam = useMemo(() => {
    if (competition) {
      // @ts-ignore
      return competition?.lmsModuleProjectId;
    }
  }, [competition]);

  const [isAutomatic, setIsAutomatic] = useState<boolean>(false);
  const [isBriefCompetition, setIsBriefCompetition] = useState<boolean>(false)
  const [briefCompetitionFlow, setBriefCompetitionFlow] = useState<
  { label: string; value: string; }>(
    { 
      label: t(`competition_edit.designFabricForm.flows.label.first`), 
      value: FABRIC_FLOW.first
    }
  );
  const [isPreRegistration, setIsPreRegistration] = useState<boolean>(false);
  const [allowEmptyParticipantRequests, setAllowEmptyParticipantRequests] = useState(false);
  const [isPaidApplication, setIsPaidApplication] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Date | undefined>();
  const [endDate_Internal, setEndDate_Internal] = useState<Date | undefined>();
  const [endDate, setEndDate] = useState<Date | undefined>();
  const [requredTags, setRequredTags] = useState<Tag[]>([]);
  const [regularTags, setRegularTags] = useState<Tag[]>([]);
  const [exclusionTags, setExclusionTags] = useState<Tag[]>([]);

  const [showShortList, setShowShortList] = useState<boolean>(false);
  const [finalistsID, setFinalistsID] = useState<string[]>([]);
  const [winnerPositions, setWinnerPostitions] = useState<{ winnerId: string, position: number }[]>([]);
  const [voteCriterias, setVoteCriterias] = useState<Criteria[]>([]);
  const [tabsData, setTabsData] = useState<Tab[]>([]);
  const [maxCriteriaCount, setMaxCriteriaCount] = useState(MIN_CRITERIA_COUNT);
  const [maxParticipantsCount, setMaxParticipantsCount] = useState('');
  const [competitionDocuments, setCompetitionDocuments] = useState<{ label: string; value: number; }[]>([]);
  const [competitionDocumentOptions, setCompetitionDocumentOptions] = useState<{ label: string; value: number; }[]>([]);

  const onUpdate = useCallback(() => setTime(Date.now()), []);

  const [ onToggleBilingual ] = useToggleBilingual(competition, onUpdate);
  const [userColor, setUserColor] = useState<string>('#464645');
  const [longReadLength, setLongReadLength] = useState(0);
  const [statusText, setStatusText] = useState('');
  const [activePicker, setActivePicker] = useState('start');
  const [mobTextBlockLength, setMobTextBlockLength] = useState(0);
  const [mobileEditorOpen, setMobileEditorOpen] = useState(false);
  const [mobileEditorAction, setMobileEditorAction] = useState<string>(LongreadMobileActions.empty);
  const toggleMobileEditor = useCallback((val: boolean) => {
    setMobileEditorOpen(val);
  }, []);

  const handlePickerOpen = (pickerName: 'start' | 'tech' | 'end') => {
    setActivePicker(pickerName);
  };

  const handlePickerClose = () => {
    setActivePicker('start');
  };

  const getZIndex = (pickerName: 'start' | 'tech' | 'end') => {
    return activePicker === pickerName ? 91 : 90 - ['start', 'tech', 'end'].indexOf(pickerName);
  };

  const vtype = useSelector((state: any) => state.vt.vtype);

  //Новый вид отображания конкурсов
  const isNewType = true;

  const isBilingual = !!competition?.isBilingual;
  bilingualRef.current = isBilingual;

  const isModer = useMemo(() => {
    if (profile) {
      const hasPolicyCompetitionModer = profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

      //Предыдущая система ролевого доступа
      const isCompetitionModer = profile.rolesList && bArray.isArray(profile.rolesList) && profile.rolesList.some(x => x === "competitionmoder");

      return bProfile.isModer(profile) || hasPolicyCompetitionModer || isCompetitionModer;
    }
  }, [profile])

  // @ts-ignore
  const isRating = competition?.isRating;

  const hasAccessToContentAdmin = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_ui_content_admin)).containsIn(profile.rolesList);

  const isBriefModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList);

  const is744BP = useBreakpoint(LayoutConst.screen.s - 1);
  const is980BP = useBreakpoint(LayoutConst.screen.m);
  const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

  const DEFAULT_CRITERIA = { label: t('competition_edit.default_criteria'), value: ''}
  const DEFAULT_MAX_CRITERIA = useMemo(() => ({ label: maxCriteriaCount?.toString(), value: maxCriteriaCount.toString()}), [maxCriteriaCount])

  competitionIdRef.current = id;
  langRef.current = i18n.language;

  const competitionTitleImages = useMemo(() => {
    if (competition) {
      return {
        titleImages: competition?.titleImages,
        titleImages_en: competition?.titleImages_en,
        isBilingual: competition?.isBilingual
      } as any;
    }
    return {} as Project<'Global'>;
  }, [competition]);

  const competitionLongreads = useMemo(() => {
    if (competition) {
      return {
        longreadId: competition.longreadId,
        longreadId_en: competition.longreadId_en,
        longread: competition.longread,
        isBilingual: competition.isBilingual
      } as any;
    }
    return {} as Project<'Global'>;
  }, [competition]);

  useEffect(() => {
    if (vtype === 'fluid' && !WIDE_SCREEN_COLORS.includes(userColor)) {
      setUserColor('#464645');
    }
  }, [vtype])

  useEffect(() => {
    if (!profile) return;

    if (id) {
      CompetitionAPI.Get({ idCompetition: id })
          .then((value) => value.json() as Promise<Competition<'Global'>>)
          .then((value) => {
            if (value.competitionId) {
              setCompetition(value);
              setIsError(false);

              if (value.administratorID?.includes(profile.accountId)
                  || value.moderatorID?.includes(profile.accountId)
                  || (isBriefModer && value?.isBriefCompetition)
                  || isModer) {
                setIsForbidden(false);
                return;
              }

              setIsForbidden(true);

            } else {
              setCompetition(undefined);
              setIsError(true);
            }
          })
          .catch((reason) => {
            console.error(reason);
            setCompetition(undefined);
            setIsError(true);
          });
      return;
    }

    if (isModer || hasAccessToContentAdmin || isBriefModer) {
      setIsCreating(true);
      CompetitionAPI.AddDefaultCompetition()
      .then((res) => res.json())
      .then((res) => {
        setTimeout(() => {
          setIsCreating(false);
          history.replace(CreateLinkTo.competitionEdit(res.competitionId));
        }, 800);
      });
      
      return;
    }

    setIsForbidden(true);
  }, [id, profile, history, isModer, hasAccessToContentAdmin, isBriefModer, time]);

  const handleToggleBilingualClick = useCallback(() => onToggleBilingual && onToggleBilingual(), [onToggleBilingual])

  const handleToggleBriefCompetitionClick = useCallback((val: boolean ) => {
    if (isModer) {
      setIsBriefCompetition(val);
      setIsPreRegistration(val);
      setCompetitionCreativeOpen(false);

      setCompetitionContexts(
        !!val ? [...competitionContexts, COMPETITIONS_CONTEXTS.briefs] : 
        competitionContexts?.filter((context ) => context !== COMPETITIONS_CONTEXTS.briefs)
      )
    }

    return;
  } , [isModer, competitionContexts])

  const updateCriteria = useCallback(() => {
    const criterias: Criteria[] = voteCriterias
      ?.map((c) => ({ ...c, maxValue: maxCriteriaCount}))
      // @ts-ignore
      ?.map((c) => slicedKey('currentLang', c, 'delete'))

    const urlUpdate = `/api/competition/UpdateVoteCriteria`;
    Promise.all(criterias?.map((c) => (
      competition?.nominations?.[0]?.nominationID
      ? API.request()
        .endpoint(Endpoints.competitions)
        .url(urlUpdate)
        .addQuery('nominationId', competition.nominations[0].nominationID)
        .body(c)
        .post()
        .send()
      : API.request()
        .endpoint(Endpoints.competitions)
        .url(urlUpdate)
        .body(c)
        .post()
        .send()
    )))
  }, [competition?.nominations, maxCriteriaCount, voteCriterias]);

  useEffect(() => {
    updateCriteria();
  }, [maxCriteriaCount])

  useEffect(() => {
    if (competition) {
      // @ts-ignore
      setCompetitionName(competition.name.length ? competition.name : defaultCompetitionName);
      setCompetitionJuryText(competition.competitionInfo.juryText ?? []);
      setCompetitionVisibility(!!competition.visibility);
      // @ts-ignore
      setCompetitionIgnoreProjectShowcase(!!competition.ignoreProjectShowcase);

      setVoteCriterias([...competition?.nominations?.[0]?.voteCriterias]?.map((crt) => computeDataWithLang(crt) as Criteria));
      // @ts-ignore
      setTabsData(competition.infoTabs.length ? competition.infoTabs : DEFAULTTABS)

      const currentStatus = STATUSES_List.find(x => x.value === competition.status);
      setCompetitionStatus(currentStatus === undefined ? undefined : {...currentStatus, label: t('competition.statuses.'+currentStatus?.label)});
      setCompetitionContexts(competition.contexts || []);
      // @ts-ignore
      setCompetitionLink(competition.link);

      // @ts-ignore
      setWinnerIntroText(competition?.winnerText_Intro?.length ? competition?.winnerText_Intro : createDefaultLangObject('', true));
      // @ts-ignore
      setWinnerFinalText(competition?.winnerText_Final?.length ? competition?.winnerText_Final : createDefaultLangObject('', true));

      setEnrollButtonText(competition?.enrollButtonText?.length ? competition?.enrollButtonText : createDefaultLangObject('', true));

      setIsAutomatic(competition.isAutomatic);

      // @ts-ignore
      setIsBriefCompetition(competition.isBriefCompetition)

      // @ts-ignore
      setEditContextText(competition?.ratingSettings?.context)

      // @ts-ignore
      if (!!competition?.briefCompetitionFlow && competition?.isBriefCompetition) {
        // @ts-ignore
        const f =  Object.entries(FABRIC_FLOW)?.find(([k,v]) => v === competition?.briefCompetitionFlow);
        //@ts-ignore
        const [k,v] = f;

        setBriefCompetitionFlow({ label: t(`competition_edit.designFabricForm.flows.label.${k}`), value: v })
        
      }

      // @ts-ignore
      setIsPreRegistration(competition.isPreRegistration)

      // @ts-ignore
      setAllowEmptyParticipantRequests(competition.allowEmptyParticipantRequests)

      // @ts-ignore
      setIsPaidApplication(!!competition.isPaidApplication)

      setMaxCriteriaCount(
        competition?.nominations?.[0]?.customVoteMaxValue ?? competition?.nominations?.[0]?.voteCriterias?.[0]?.maxValue);

      if (competition.startDate) {
        let date = fixTimezoneOffsetToShow(new Date( Date.parse(competition.startDate) ));
        setStartDate(date);
      }

      if (competition.endDate_Internal) {
        let date = fixTimezoneOffsetToShow(new Date( Date.parse(competition.endDate_Internal) ));
        setEndDate_Internal(date);
      }

      if (competition.endDate) {        
        let date = isExam ? fixTimezoneLMSExamShow(new Date( Date.parse(competition.endDate) )) : fixTimezoneOffsetToShow(new Date( Date.parse(competition.endDate) ));
        setEndDate(date);
      }

      const ownRequredTags = [...competition.requredTags].map((tag) => {
        const translatedTag = API.toLang<Tag>(tag, i18n.language);
        return {
          ...translatedTag,
        }
      });

      setRequredTags(ownRequredTags);

      const ownRegularTags = [...competition.regularTags].map((tag) => {
        const translatedTag = API.toLang<Tag>(tag, i18n.language);
        return {
          ...translatedTag,
        }
      });

      setRegularTags(ownRegularTags);

      const ownExclusionTags = [...competition.exclusionTags].map((tag) => {
        const translatedTag = API.toLang(tag, i18n.language);
        return {
          //@ts-ignore
          ...translatedTag,
        }
      });

      setExclusionTags(ownExclusionTags);

      if (!!competition.maxParticipantsCount) {
        if (competition.maxParticipantsCount > DEFAULT_PARTICIPANTS_COUNT) {
          setMaxParticipantsCount(competition.maxParticipantsCount.toString());
        }
        else {
          setMaxParticipantsCount('');
        }
      }
      else {
        setMaxParticipantsCount('');
      }

      if (competition.competitionColorTheme?.backgroundColor) {
        setUserColor(competition.competitionColorTheme.backgroundColor === '#FEFEFE' ? '#464645' : competition.competitionColorTheme.backgroundColor);
      }

      if (competition.nominations[0]) {
        setCompetitionCreativeOpen(competition.nominations[0].needToFillForm);
        // @ts-ignore
        setShowShortList(competition.nominations[0].showShortList);
        setFinalistsID(competition.nominations[0].finalistsID);

        //@ts-ignore
        setWinnerPostitions(competition.nominations[0].winnerPositions);
      }

      CompetitionAPI.GetVoteCriteriaList()
        .then((r) => r.json())
        .then((r) => setCriteriaList(r))
    }
  }, [competition, isBriefModer, t, i18n]);

  useEffect(() => {
    if (competition) {
      const administrators = (competition.administrators || []) as Designer<'Global'>[];
      const moderators = (competition.moderators || []) as Designer<'Global'>[];
      const juries = (competition.juries || []) as Designer<'Global'>[];

      setCompetitionAdministrators(administrators.length !== 0 ? [
        {
          ...convertDesignerFromGlobalToLocal(administrators[0], i18n.language),
          disabled: true
        },
        ...administrators.slice(1).map(admin => convertDesignerFromGlobalToLocal(admin, i18n.language))
      ] : []);

      setCompetitionModerators(moderators.map((moder) => convertDesignerFromGlobalToLocal(moder, i18n.language)));
      setCompetitionJury(juries.map((jury) => convertDesignerFromGlobalToLocal(jury, i18n.language)));
    }
  }, [
    competition,
    i18n.language
  ]);

  useEffect(() => {
    if (competition) {
      DocumentAPI.GetDocumentsService({
        service: ["competitions"]
      })
      .then(data => data.json())
      .then(data => {
        if (data?.length) {
          const options = data?.map((item, index) => ({ label: item?.documentId, value: index }));
          setCompetitionDocumentOptions(options);
          if (competition?.nominations?.[0]) {
           setCompetitionDocuments(options?.filter(x => competition?.nominations?.[0]?.documentsIds.includes(x?.label)));
         }
        }
      });
    }
  }, [competition]);

  useEffect(() => {
    if (competition && competition.competitionId) {
      if (throttle.current) {
        clearTimeout(throttle.current);
        throttle.current = null;
      }

      setStatusText(t('saving'));

      throttle.current = setTimeout(() => {
        if (competition && competition.competitionId) {
          const copy: Competition<'Global'> = {
            ...competition
          };
          copy.administratorID = competitionAdministrators.map(x => x.accountId);
          copy.moderatorID = competitionModerators.map(x => x.accountId);
          copy.juryID = competitionJury.map(x => x.accountId);
          copy.competitionInfo.juryText = competitionJuryText;
          copy.visibility = competitionVisibility;
          //@ts-ignore
          copy.ignoreProjectShowcase = competitionIgnoreProjectShowcase;
          copy.status = competitionStatus?.value ?? 0;
          copy.contexts = competitionContexts;
           if (outerLinkIsValid) {
               copy.link = competitionLink;
             }
          //@ts-ignore
          copy.infoTabs = tabsData.length ? tabsData : DEFAULTTABS;
          copy.competitionColorTheme = {
            backgroundColor: userColor,
            accentColor: null,
            fontColor: null,
            bannerFontColor: null,
            stagesBackgroundColor: null,
            stagesFontColor: null,
            buttonBackgroundColor: null,
            buttonFontColor: null,
           };

          if (competitionName) {
            copy.name = competitionName;
            copy.title = competitionName;
          }

          if (copy.nominations[0]) {
            copy.nominations[0].needToFillForm = competitionCreativeOpen;
            copy.nominations[0].documentsIds = competitionDocuments.map(item => item.label);
            // @ts-ignore
            copy.nominations[0].showShortList = showShortList;
            copy.nominations[0].finalistsID = finalistsID;
            //@ts-ignore
            copy.nominations[0].winnerPositions = winnerPositions?.filter(x => !x?.isEmpty);
            //@ts-ignore
            const filterCriterias = voteCriterias?.filter((crt) => !crt?.isNew)
            //@ts-ignore
            copy.nominations[0].voteCriteriasID = filterCriterias?.map((crt) => (crt.voteCriteriaId)) 
            copy.nominations[0].customVoteMaxValue = maxCriteriaCount;
            copy.nominations[0].customVoteMinValue = 1;
          }

          copy.isAutomatic = isAutomatic;
          copy.isPreRegistration = isPreRegistration;
          //@ts-ignore
          copy.allowEmptyParticipantRequests = allowEmptyParticipantRequests;
          //@ts-ignore
          copy.isPaidApplication = isPaidApplication;
          copy.isNewType = isNewType;
          copy.startDate = fixTimezoneOffsetToSave(startDate)?.toJSON();
          copy.endDate_Internal = fixTimezoneOffsetToSave(endDate_Internal)?.toJSON();
          copy.endDate = isExam ? fixTimezoneLMSExam(endDate)?.toJSON() : fixTimezoneOffsetToSave(endDate)?.toJSON();
          copy.requredTagIds = [...requredTags].map((value) => value.tagId);
          copy.regularTagIds = [...regularTags].map((value) => value.tagId);
          copy.exclusionTagIds = [...exclusionTags].map((value) => value.tagId);
          copy.maxParticipantsCount = Number(maxParticipantsCount);
          //@ts-ignore
          copy.ratingSettings = isRating ? {...competition?.ratingSettings, context: editContextText} : null;
          copy.isBriefCompetition = isBriefCompetition;

          if (isBriefCompetition) {
            //@ts-ignore
            copy.briefCompetitionFlow = briefCompetitionFlow.value;
          }

          //@ts-ignore
          copy.winnerText_Intro = winnerIntroText;
          //@ts-ignore
          copy.winnerText_Final = winnerFinalText;
          copy.enrollButtonText = enrollButtonText;

          CompetitionAPI.Update(copy)
            .then(() => {
              setTimeout(() => setStatusText(t('saved')), 1000);
            })
            .catch(() => setIsUpdateError(true));
        }
      }, 1000);
    } else {
      setStatusText('Loading competition...');
    }
  }, [
    history,
    competition,
    profile,
    competitionName,
    maxParticipantsCount,
    competitionAdministrators,
    maxCriteriaCount,
    competitionModerators,
    competitionJury,
    competitionJuryText,
    voteCriterias,
    competitionVisibility,
    isBriefCompetition,
    briefCompetitionFlow,
    competitionIgnoreProjectShowcase,
    isPreRegistration,
    allowEmptyParticipantRequests,
    isPaidApplication,
    competitionStatus,
    competitionContexts,
    competitionCreativeOpen,
    winnerIntroText,
    winnerFinalText,
    isAutomatic,
    startDate,
    endDate_Internal,
    endDate,
    requredTags,
    regularTags,
    exclusionTags,
    showShortList,
    finalistsID,
    winnerPositions,
    competitionDocuments,
    userColor,
    isExam,
    competitionLink,
    enrollButtonText,
    tabsData,
    editContextText,
    id,
    t,
  ]);

  useEffect(() => {
    if (competition?.longread) {
      dispatch(setType(competition?.longread?.viewType || 'container'));
    }

  }, [competition, dispatch])

  const getRedirectIfBackClick = useCallback(() => {
    //@ts-ignore
    history.push(competition?.lmsModuleProjectId ? CreateLinkTo.projectEdit(competition?.lmsModuleProjectId) : CreateLinkTo.competitionsAdmin());
  }, [history, competition]);

  const uploaderCallback = useCallback((fileId: Voidable<string>) => {
    if (!fileId) {
      return null;
    }
    CompetitionAPI.UploadFile({
      fileId,
      profileId: competitionIdRef.current,
      service: 'geography',
      entityType: 'competitionimage',
      ...(bilingualRef.current === true ? {
        localization: langRef.current,
      } : {})
    })
    .then((res) => {
      sipRef.current.uploader.uploader.uppy.reset();
      return res;
    });
  }, [competitionIdRef, bilingualRef, langRef])

  const uploadValidator = useCallback(async (files: any) => {
    let failedChecks: {
      dimensions?: boolean;
      size?: boolean;
      ratio?: boolean;
      type?: boolean;
    } = {};

    if (!['image/jpeg'].includes(files?.[0]?.type)) {
      toasts.error(t('project_edit.image_error.wrong_format'));
      failedChecks.size = true;
    }

    const {
      size: failedSize,
    } = failedChecks;

    if (failedSize) {
      return false;
    }

    return true;
  }, [t]);

  const sip = useSimpleUploader(uploaderCallback, uploadValidator);
  const sip_en = useSimpleUploader(uploaderCallback, uploadValidator);
  sipRef.current = sip;
  sipRefEn.current = sip_en;

  const outerLinkIsValid = useMemo(
    () => (competitionLink?.length ? !!COMPETITION_LINK_REG.test(competitionLink) : true) , [competitionLink]);

  const errorsArray = useMemo(() => {
    const errors = [];
    if(requredTags.length === 0 && !isRating){
      errors.push(`${t('create.tips.fill')}`);
    }

    if (!outerLinkIsValid) {
      errors.push(`${t('create.tips.wrong_link_format')}`);
    }
    return errors;
  }, [outerLinkIsValid, requredTags, t])

  const primaryButtonText = useMemo(() => t('save'), [t]);
  const emptyVoteCriterias = voteCriterias?.some(item => Lang(item?.name, 'ru') === '')
  const primaryButtonClick = useCallback((): void => {
    if (!!mobileEditorOpen) {
      setMobileEditorAction(LongreadMobileActions.add);
      setMobTextBlockLength(0);
      setTimeout(() => {
        setMobileEditorAction(LongreadMobileActions.empty);
        toggleMobileEditor(false);
      }, 1000);
      return;
    }

    // @ts-ignore
    if (competition?.lmsModuleProjectId) {
      // @ts-ignore
      history.push(CreateLinkTo.projectEdit(competition?.lmsModuleProjectId))
      return
    }
    if (profile && (isModer || hasAccessToContentAdmin || isBriefModer)) {
        history.push(CreateLinkTo.competitionsAdmin());
    }
  }, [history, profile, isModer, hasAccessToContentAdmin, isBriefModer, competition, mobileEditorOpen, toggleMobileEditor]);

  const hasTitle = useMemo(
    () => !!competitionName?.length && competitionName?.every((i) => i?.name !== ''), [competitionName])


  const handleSetMobTextLengthChange = useCallback((val: number) => {
    setMobTextBlockLength(val);
  }, []);



  const canSaveLgText = useMemo(
    () => mobTextBlockLength > 0, 
    [mobTextBlockLength]
  );

   
  const PortalMenu = useMemo(() => {
    const outer = document.getElementById('navbar-portal');

    if (!outer) {
      return null;
    }
    
    const isReadyToNext = (hasTitle && !!requredTags.length && outerLinkIsValid && !emptyVoteCriterias && !!startDate && !!endDate_Internal && !!endDate ) || isRating || (!!mobileEditorOpen ? canSaveLgText : false);
    return createPortal(
              <NavbarCreate
          className={className}
          isReadyToNext={isReadyToNext}
          primaryButtonEnabled={isReadyToNext}
          primaryButtonText={primaryButtonText}
          stateText={statusText}
          onSecondaryClick={getRedirectIfBackClick}
          onPrimaryClick={primaryButtonClick}
          errors={errorsArray}
          previewButtonVisible={false}
          mobileEditorOpen={mobileEditorOpen}
          toggleMobileEditor={toggleMobileEditor}
          // @ts-ignore
          isLMSModule={!!competition?.lmsModuleProjectId}
        />,
      outer,
    );
  }, [
    longReadLength,
    hasTitle,
    className,
    primaryButtonText,
    statusText,
    primaryButtonClick,
    getRedirectIfBackClick,
    errorsArray,
    mobTextBlockLength,
    mobileEditorOpen,
    canSaveLgText,
    mobileEditorAction,
    requredTags,
    outerLinkIsValid,
    emptyVoteCriterias,
    startDate,
    endDate_Internal,
    endDate,
    isRating
  ]);

  const brighter = useMemo(() => bColor.getBrighter(userColor, 10), [userColor]);
  const darker = useMemo(() => bColor.getBrighter(userColor, -20), [userColor]);
  const custom = {
    customBackgroundColor: Colors.galBlack5,
    customBorderColor: 'transparent',
    customBorderColorHover: 'transparent',
    customTextColor: Colors.galBlack100,
    customPlaceholderColor: Colors.galBlack47,
  };


  const CriteriaOptions = useMemo(() => {
    if (criteriaList?.length) {
      //@ts-ignore
        return criteriaList?.reduce((acc,val) => {
          return [...acc, { label: Lang(val?.name, i18n.language), value: val?.voteCriteriaId }]
      }, [])
    }
  }, [criteriaList, i18n.language]);

  const criteriaMaxValues = useMemo(() => {
    const list = [MIN_CRITERIA_COUNT, MAX_CRITERIA_COUNT];
      //@ts-ignore
        return list?.reduce((acc,val) => {
          return [...acc, { label: val, value: val}]
      }, [])

  }, [i18n.language]);

  const competitionFinish = useMemo(
    () => (competitionStatus?.value && [STATUSES.Completed, STATUSES.Archived]?.includes(competitionStatus?.value)), [competitionStatus])

  const onCompetitionNameChange = useCallback((value: string) => {
    setCompetitionName(setCompetitionStringValueByLang(competition?.isBilingual || false, competitionName, i18n.language, value))
  }, [competitionName, i18n.language, competition]);

  const onCompetitionAdministratorsChange = useCallback(({ authors, action }: ProjectAuthorsChangeCbT) => {
    if (action === 'remove-value') {
      if (authors.length === 0) {
        toasts.error('администраторов не может быть 0');
        return;
      }
    }
    setCompetitionAdministrators(authors);
  }, [toasts]);

  const onTeamTabSortEnd = useCallback((oldIndex: number, newIndex: number) => {
    const tabs = arrayMoveImmutable(voteCriterias, oldIndex, newIndex)
    setVoteCriterias(tabs);
  }, [setVoteCriterias, voteCriterias]);

  const allowedCriteriaValue = (crt: Criteria) => {
    // @ts-ignore
    const name = Lang(crt?.name, crt?.currentLang || i18n.language);
    // @ts-ignore
    if (crt?.isNew && !!name?.length) {

      const namesRu = criteriaList?.map((crt) => {
        return crt?.name[0]?.name?.toLowerCase()
      });
    
      const namesEng = criteriaList?.map((crt) => {
        return crt?.name[1]?.name?.toLowerCase()
      });
    
      return [...namesRu, ...namesEng]?.includes(name)
    }

    return false;
  } 

  const onCriterialNameChange = (text: string,  id: string, lang: string) => {
      const criterias = voteCriterias?.map((crt) => {
        if (crt?.voteCriteriaId === id) {
          return {
            ...crt, name: setTextByLang(crt?.name, lang, text)
          }
        }
        return crt
      });
      setVoteCriterias(criterias);  
  };
    
  const onTabNameChange = (text: string, id: string, lang: string) => {
    const updatedTabs = tabsData.map((tab) => {
      if (tab.position === Number(id)) { 
        return {
          ...tab,
          name: setTextByLang(tab.name, lang, text)
        };
      }
      return tab;
    });
    setTabsData(updatedTabs); 
  };

  const onTabCheckboxChange = (value: boolean, id: number) => {
    const updatedTabs = tabsData.map((tab) => {
      if (tab.position === Number(id)) { 
        return {
          ...tab,
          enable: value
        };
      }
      return tab;
    });
    setTabsData(updatedTabs); 
  };

  const onCriteriaDeleteClick = (id: string) => {
    const confirmation = window.confirm('Вы действительно хотите удалить критерий?');
    if (confirmation) {
      setVoteCriterias(voteCriterias?.filter((crt) => crt?.voteCriteriaId !== id));
    }
  }

  const onSubmitNewCriteria = (crt: Criteria) => {
    const computeCriteria = {
      name: crt?.name as LangObject[],
      voteCriteriaId: crt?.voteCriteriaId,
      maxValue: maxCriteriaCount,
      minValue: 1
    }
    CompetitionAPI.AddVoteCriteria(computeCriteria)
    .then((r) => r.json())
    .then((r) => {
      if (!!r?.length) {
        setVoteCriterias([...voteCriterias?.slice(0, voteCriterias?.length - 1), { ...computeCriteria, voteCriteriaId: r }])
      }

      CompetitionAPI.GetVoteCriteriaList()
    });
  }

  const onCreateNewCriteria = () => {
    const defaultCrt = { voteCriteriaId: '', name: createDefaultLangObject(''), maxValue: maxCriteriaCount, minValue: 1, isNew: true}
    setVoteCriterias([...voteCriterias, defaultCrt]);
  }

  const onCompetitionModeratorsChange = ({ authors }: ProjectAuthorsChangeCbT) => {
    setCompetitionModerators(authors);
  };

  const onCompetitionJuryChange = ({ authors }: ProjectAuthorsChangeCbT) => {
    setCompetitionJury(authors);
  };

  const onCompetitionJuryTextChange = useCallback((value: string) => {
    setCompetitionJuryText(setCompetitionStringValueByLang(false, competitionJuryText, i18n.language, value))
  }, [competitionJuryText, i18n.language]);

  const onSortWinners = useCallback((oldIndex: number, newIndex: number): void => {
    const arr = arrayMoveImmutable(winnerPositions, oldIndex, newIndex)
    setWinnerPostitions(arr);
  }, [winnerPositions]);

  const onDeleteContext = (i: string) => {
    const confirm = window.confirm(t('confirmation.context_delete'))

    if (confirm) {

      if (isBriefModer && i === COMPETITIONS_CONTEXTS.briefs) {
        toasts.error('Вы не можете удалить бриф контекст. Обратитесь к модератору');
        return;
      }
      setCompetitionContexts(competitionContexts?.filter((k) => k !== i));

      if (i === COMPETITIONS_CONTEXTS.briefs) {
        setIsBriefCompetition(false)
      }
    }
  }

  const minStartDate = useMemo(() => {
    const date = new Date(Date.now())

    if (competitionFinish) {
      return undefined;
    }
    
    if (startDate && startDate < date) {
      return startDate;
    }

    return date;
  }, [startDate, competitionFinish]);

  const handleDateChange = (setDateFunction: any) => (value: Date) => {
    setDateFunction(value);
  };
  
  const handleBlur = (setDateFunction: any, currentDate: Date | undefined) => () => {
    const minDate = new Date();
      
    if (currentDate && currentDate < minDate) {
      handleDateChange(setDateFunction)(minDate);
    }
    if (currentDate === undefined || currentDate === null) {
      setDateFunction(fixTimezoneOffsetToShow(new Date(Date.now())));
    }
  };
  const handleCompetitionBlur = (setDateFunction: any, currentDate: Date | undefined) => () => {
    const minDate = new Date(2022, 0, 1); 
    
    if (currentDate && currentDate < minDate) {
      handleDateChange(setDateFunction)(minDate);
    }
    if (currentDate === undefined || currentDate === null) {
      setDateFunction(fixTimezoneOffsetToShow(new Date(Date.now())));
    }
  };
  const handleEndDateBlur = (setDateFunction: any, currentDate: Date | undefined) => () => {
    
    if (startDate && currentDate && currentDate < startDate) {
      handleDateChange(setDateFunction)(startDate);
    }
    if (currentDate === undefined || currentDate === null) {
      setDateFunction(fixTimezoneOffsetToShow(new Date(Date.now())));
    }
  };

  const rebuildWinnerPositions = useCallback((items: {project?: Project, position?: number, isEmpty?: boolean, projectId?: string}[], isDelete?: boolean) => {
    const temp = items.map((x, idx )=> {
      const current = winnerPositions.find(f => f.winnerId === x?.project?.projectId);

      return { winnerId: isDelete ? x?.projectId || '' : x?.project?.projectId || "", position: !current ? idx + 1 : current.position };
    });

    setWinnerPostitions(temp);
  }, [winnerPositions]);

  const onSetWinnerPostitions = useCallback((projectIds: string[], position?: number) => {
    const temp = projectIds?.reverse().map((x, idx) => {
      const current = winnerPositions.find(f => f.winnerId === x);

      return { winnerId: x, position: !current ? idx + 1 : current.position };
    });

    setWinnerPostitions(temp);
  }, [winnerPositions]);

  const onSetWinnerPosition = useCallback((index: number, position: number) => {
    const temp = [...winnerPositions];
    temp[index].position = position;
    setWinnerPostitions(temp);
  }, [winnerPositions]);

  const onLocalLangChange = (arr: any[], lang: string, callback: (test: any[]) => void) => callback(arr?.map((i: any) => ({ ...i, currentLang: lang === 'ru' ? 'en' : 'ru' })));

  const onLocalLangChanges = (
    arr: any[], 
    lang: string, 
    tabId: string, 
    callback: (updatedTabs: any[]) => void
  ) => {
    const updatedTabs = arr.map((tab: any) =>
        tab.tabId === tabId
            ? { ...tab, currentLang: lang === 'ru' ? 'en' : 'ru' }
            : tab 
    );
    
    callback(updatedTabs);
  };
  const criteriasBlock = useMemo(() => {
    // @ts-ignore
    const currentLang = voteCriterias?.find((crt) => crt?.currentLang)?.currentLang || 'ru';
    // @ts-ignore
    const hasNewCriteria = voteCriterias?.some((crt) => crt?.isNew);

    return (
      <CriteriaWrapper gyMobile={8} offsetBottom={isMac13 ? 40 : 56} offsetBottomMobile={40} direction="column" directionMobile="column">
        <LangTitleBox 
          title={t('competition_edit.labels.criterias')} 
          mainTitle 
          onLangChange={() => onLocalLangChange(voteCriterias, currentLang, (val) => setVoteCriterias(val))} 
          lang={currentLang} 
          isCompetitionEdit
        />
        {!!criteriaList?.length && (
          <FlexBox offsetTop={24} offsetTopMobile={1}>
            <CommonInput 
              type={INPUT_TYPES.dropdown}
              value={DEFAULT_CRITERIA}
              //@ts-ignore
              options={CriteriaOptions}
              onChange={(item: any, currentLang?: string) => {
                const crt = criteriaList?.find((crt) => crt?.voteCriteriaId === item?.value);
                const has = voteCriterias?.find((crt) => crt?.voteCriteriaId === item?.value) 
                if (crt && !has) {
                  setVoteCriterias([...voteCriterias, crt])
                }
              }}
            />
          </FlexBox>
        )}
        <FlexBox offsetTop={24} offsetTopMobile={24} direction="row" directionMobile="column" width={'100%'} justify="space-between" align="center">
          <CriteriaMaxValueLabel width={'calc(100% - 292px)'} widthMobile={'100%'} offsetBottomMobile={8}>
            {t('competition_edit.default_max_criteria')}
          </CriteriaMaxValueLabel>
          <FlexBox width={'292px'} widthMobile={'100%'}>
            <CommonInput 
              type={INPUT_TYPES.dropdown}
              options={criteriaMaxValues as any}
              value={DEFAULT_MAX_CRITERIA}
              onChange={(item: any) => {
                setMaxCriteriaCount(item?.value)
              }}
            />
          </FlexBox>
        </FlexBox>
        {!!voteCriterias?.length && (
          <SortableWrapper offsetTop={24} offsetTopMobile={16}>
            <SortableList as={'tbody'} onSortEnd={onTeamTabSortEnd}>
              {voteCriterias.map((crt, index) => {
                const name = Lang(crt.name, currentLang);
                // @ts-ignore
                const isNewCriteria = crt?.isNew;

                if (isNewCriteria) {
                  return (
                    <div>
                          <tr>
                            <td style={{ width: '100%', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                  <SortableKnob>
                                    <div style={{  
                                      cursor: 'not-allowed' , 
                                      backgroundColor: 'transparent', 
                                      ...(isNewCriteria && { pointerEvents: 'none' }),
                                      }}
                                    >
                                      <DottedIcon />
                                    </div>
                                  </SortableKnob>
                                    <CommonInput 
                                      type={INPUT_TYPES.text}
                                      maxLength={100}
                                      disable={!isNewCriteria}
                                      value={!!name ? name : ''}
                                      onChange={(ev: any) => onCriterialNameChange(ev?.target?.value, crt?.voteCriteriaId, currentLang)}
                                    />
                                    {!!allowedCriteriaValue(crt) && (
                                      <span className={'not-allowed-text'}>{t('competition_edit.error_criteria_text')}</span>
                                    )}
                                    {emptyVoteCriterias && (
                                      <span className={'not-allowed-text'}>{t('competition_edit.fill_criteria_text')}</span>
                                    )}
                                    {isNewCriteria && (
                                      <Counter>{`${name?.length}/100`}</Counter>
                                    )}
                                </TableSortWrapper>
                            </td>
                            <td style={{ paddingLeft: 24, width: !isNewCriteria ? 131 : 'auto', padding: isMobile ? '8px 0px' : '' }}>
                                <FlexBox direction={'row'} directionMobile="row" gx={isNewCriteria ? 10 : 0} gxMobile={isNewCriteria ? 10 : 0} justify={isNewCriteria ? 'center' : 'end'} width={isNewCriteria ? '100%' : '131px'} widthMobile={'100%'} justifyMobile={isMobile ? 'end' : 'start'}>
                                  {isNewCriteria ? (
                                    <FlexBox direction="row" justify="center" gx={20} gxMobile={20}>
                                      <ApprovedIcon disabled={emptyVoteCriterias} className={'icon'} fill={'#909090'}  display={true} width={25} height={25} onClick={() => onSubmitNewCriteria(crt)}/>
                                      <BasketIcon className={'icon'} fill={'#909090'} onClick={() => onCriteriaDeleteClick(crt?.voteCriteriaId)}/>
                                    </FlexBox>
                                  ) : (
                                    <DefaultButton wh={131} whMob={107} onClick={() => onCriteriaDeleteClick(crt?.voteCriteriaId)}>Удалить</DefaultButton>
                                  )}
                                
                                </FlexBox>
                            </td>
                        </tr>
                    </div>
                  )
                }
                return (
                    <SortableItem key={"team-tab-sortable_" + index}>
                        <tr>
                            <td style={{ width: '100%', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                  <SortableKnob>
                                    <div style={{
                                      cursor: 'grab',   
                                      backgroundColor: 'transparent', 
                                      }}
                                    >
                                      <DottedIcon />
                                    </div>
                                  </SortableKnob>
                                    <Input.Text 
                                      maxLength={100}
                                      value={!!name ? name : ''}
                                      disabled={!isNewCriteria}
                                      //@ts-ignore
                                      onChange={(ev) => onCriterialNameChange(ev?.target?.value, crt?.voteCriteriaId, currentLang)}
                                    />
                                    {!!allowedCriteriaValue(crt) && (
                                      <span className={'not-allowed-text'}>{t('competition_edit.error_criteria_text')}</span>
                                    )}
                                    {isNewCriteria && (
                                      <Counter>{`${name?.length}/100`}</Counter>
                                    )}
                                </TableSortWrapper>
                            </td>
                            <td style={{ paddingLeft: 24, width: !isNewCriteria ? 131 : 'auto', padding: isMobile ? '8px 0px' : '' }}>
                                <FlexBox direction={'row'} directionMobile="row" gx={isNewCriteria ? 10 : 0} gxMobile={isNewCriteria ? 10 : 0} justify={isNewCriteria ? 'center' : 'end'} width={isNewCriteria ? '100%' : '131px'} widthMobile={'100%'} justifyMobile={isMobile ? 'end' : 'start'}>
                                    <DefaultButton wh={131} whMob={107} onClick={() => onCriteriaDeleteClick(crt?.voteCriteriaId)}>Удалить</DefaultButton>
                                </FlexBox>
                            </td>
                        </tr>
                    </SortableItem>
                );
              })}
            </SortableList>
          </SortableWrapper>
        )}
        {!hasNewCriteria && (
          <FlexBox offsetTop={10}>
            <DefaultButton wh={195} whMob={195} onClick={() => {
                onCreateNewCriteria();
            }}>
              <PlusSvg />
                Создать
            </DefaultButton>
        </FlexBox>
        )}

    </CriteriaWrapper>
    )
  }, [voteCriterias, CriteriaOptions, isMac13, criteriaMaxValues, DEFAULT_MAX_CRITERIA])

  const hasTag = useCallback((currentTags: Tag[],tags: Tag[]) => {
    return !!currentTags
    ?.map((tag) => tag?.tagId)
    ?.find((i) => tags
      ?.some(({ tagId }) => tagId === i)
    )
  }, [])

  const winnerTextBlock = useMemo(() => {

    return (
      <CompetitionEditPageGridRow>
         <CommonInput 
          minHeight={120}
          orientation="wide"
          type={INPUT_TYPES.textarea}
          maxLength={800}
          label={t('competition_edit.winner_intro_text')}
          value={winnerIntroText}
          useLangSwitcher
          onChange={(value: any, currentLang?: string) => setWinnerIntroText(setTextByLang(winnerIntroText, currentLang ?? 'ru', value.target.value))}
        />
      </CompetitionEditPageGridRow>
    )
  }, [winnerIntroText]);

  const winnerFinalTextBlock = useMemo(() => {
    return (
      <CompetitionEditPageGridRow>
        <CommonInput 
          minHeight={120}
          orientation="wide"
          type={INPUT_TYPES.textarea}
          maxLength={800}
          label={t('competition_edit.winner_final_text')}
          value={winnerFinalText}
          useLangSwitcher
          onChange={(value: any, currentLang?: string) => setWinnerFinalText(setTextByLang(winnerFinalText, currentLang ?? 'ru', value.target.value))}
      />
      </CompetitionEditPageGridRow>
    )
  }, [winnerFinalText])

  const requiredTagsInput = useMemo(() => <TagsWrapper isExam={isExam}>
    <CompetitionEditPageGridLabel {...custom} nowrap>
      {t('competition_edit.required_tags')}
     {!isRating && <LabelRedStar>*</LabelRedStar>} 
    </CompetitionEditPageGridLabel>
    <CompetitionContentAddContainer>
      {/* @ts-ignore */}
      {!competition?.lmsModuleProjectId && <AddTagsWrapper
          isEmpty={!requredTags?.length}
          onClick={() => modal.show('tags', {
            value: [...requredTags],
            global: true,
            isEdit: true,
            // global: true,
            onChange: (tagsRaw: Tag[]) => {
              if (hasTag(exclusionTags, tagsRaw)) {
                toasts.error(t('project_edit.unic_tags'))
                return;
              }

              setRequredTags(tagsRaw);
            }
          })}>
        <PlusIconThin/>
        <ButtonText>{t('project_edit.tags_button_empty_text')}</ButtonText>
      </AddTagsWrapper>}
      {!!requredTags?.length && (
          <BTagsGridNew scrollMode="all" style={{ marginBottom: "0px" }}>
            {[...requredTags].map((value: any) => (
                <BTag
                    tag={value}
                    removable
                    educational={value.isEducationTag}
                    isProjectsTag
                    onClick={() => {
                      // @ts-ignore
                      if (!competition?.lmsModuleProjectId) setRequredTags((v) => v.filter((tag) => tag.tagId !== value.tagId));
                    }}
                    key={value.tagId}
                >
                  {bTag.title(value)}
                </BTag>
            ))}
          </BTagsGridNew>
      )}
    </CompetitionContentAddContainer>
    {/* @ts-ignore */}
  </TagsWrapper>, [t, setRequredTags, requredTags, regularTags, isExam, competition?.lmsModuleProjectId, hasTag, exclusionTags])

  // @ts-ignore
  const submitButton = useMemo(() => <ButtonFilled isLMS={competition?.lmsModuleProjectId} disabled={!hasTitle} onClick={primaryButtonClick}>{primaryButtonText}</ButtonFilled>, [t, primaryButtonClick, primaryButtonText, hasTitle])

  const regularTagsInput = useMemo(() => <TagsWrapper isExam={isExam}>
    <CompetitionEditPageGridLabel {...custom}>
      {t('competition_edit.default_tags')}
    </CompetitionEditPageGridLabel>
    <CompetitionContentAddContainer>
      {/* @ts-ignore */}
      {!competition?.lmsModuleProjectId && <AddTagsWrapper
          isEmpty={!regularTags?.length}
          onClick={() => modal.show('tags', {
            value: regularTags,
            isEdit: true,
            onChange: (tagsRaw: Tag[]) => {
              setRegularTags(tagsRaw);
            }
          })}>
        <PlusIconThin/>
        <ButtonText>{t('project_edit.tags_button_empty_text')}</ButtonText>
      </AddTagsWrapper>}
      {!!regularTags?.length && (
          <BTagsGridNew style={{ marginBottom: "0px" }}>
            {regularTags.map((value: any) => (
                <BTag
                    tag={value}
                    removable
                    educational={value.isEducationTag}
                    isProjectsTag
                    onClick={() => {
                      // @ts-ignore
                      if (!competition?.lmsModuleProjectId) setRegularTags((v) => v.filter((tag) => tag.tagId !== value.tagId));
                    }}
                    key={value.tagId}
                >
                  {bTag.title(value)}
                </BTag>
            ))}
          </BTagsGridNew>
      )}
    </CompetitionContentAddContainer>
    {/* @ts-ignore */}
  </TagsWrapper>, [t, setRegularTags, regularTags, isExam, competition?.lmsModuleProjectId])

  const excludingTagsInput = useMemo(() => <TagsWrapper isExam={isExam}>
    <CompetitionEditPageGridLabel {...custom}>
      {t('competition_edit.excluding_tags')}
    </CompetitionEditPageGridLabel>
    <CompetitionContentAddContainer>
      <AddTagsWrapper
          isEmpty={!exclusionTags?.length}
          onClick={() => modal.show('tags', {
            value: exclusionTags,
            isEdit: true,
            onChange: (tagsRaw: Tag[]) => {
              if (hasTag(requredTags, tagsRaw)) {
                toasts.error(t('project_edit.unic_tags'))
                return;
              }
              setExclusionTags(tagsRaw);
            }
          })}>
        <PlusIconThin/>
        <ButtonText>{t('project_edit.tags_button_empty_text')}</ButtonText>
      </AddTagsWrapper>
      {!!exclusionTags?.length && (
          <BTagsGridNew style={{ marginBottom: "0px" }}>
            {exclusionTags.map((value: any) => (
                <BTag
                    tag={value}
                    removable
                    educational={false}
                    isProjectsTag
                    onClick={() => {
                      setExclusionTags((v) => v.filter((tag) => tag.tagId !== value.tagId));
                    }}
                    key={value.tagId}
                >
                  {bTag.title(value)}
                </BTag>
            ))}
          </BTagsGridNew>
      )}
    </CompetitionContentAddContainer>
  </TagsWrapper>, [t, setExclusionTags, exclusionTags, isExam, hasTag, requredTags])


  const competitionExamNameInput = useMemo(() => (
    <CommonInput 
      type={INPUT_TYPES.text}
      label={t('teams.adminPage.fields.name')}
      value={Lang(competitionName, i18n.language)}
      onChange={(value: any) => onCompetitionNameChange(value.target.value)}
      disable
    />
  ), [t, competitionName, i18n, onCompetitionNameChange])

  const filteredStatuses = STATUSES_List.filter(item =>
  ['Open', 'Voting', 'Completed'].includes(item.label)
  );
  const getLabel = (label: string | undefined) => {
    if (label === 'Voting') {
      return t('competition.statuses.VotingLMS');
    }
    return t('competition.statuses.' + label);
  };
  // @ts-ignore
  const competitionStatusInput = useMemo(() => {
    const value = {label: getLabel(STATUSES?.[competitionStatus?.value || 1]), value: competitionStatus?.value} as any;
    const opt = filteredStatuses.map(item => ({...item, label: getLabel(item.label)})) as any
    return (
      <CommonInput 
      type={INPUT_TYPES.dropdown}
      label={t('competition_edit.status')}
      options={opt}
      value={value}
      onChange={(item: any) => setCompetitionStatus(item)}
    />
    )
  }, [t, isMobile, competitionStatus, setCompetitionStatus])

  const startDateInput = useMemo(() => <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('start') }}>
    {/* @ts-ignore */}
    <CompetitionEditPageGridLabel isLMS={competition?.lmsModuleProjectId}>
      {/* @ts-ignore */}
      {competition?.lmsModuleProjectId ? t('competition_edit.exam_start_date') : t('competition_edit.start_date')}
    </CompetitionEditPageGridLabel>
    {/* @ts-ignore */}
    <CompetitionEditPageGridStartLabel  isLMS={competition?.lmsModuleProjectId}>
      <CustomDateTimePicker
          value={startDate}
          className="date-input"
          calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
          clearIcon={null}
          format="dd-MM-yyyy HH:mm:ss"
          maxDate={new Date('9999-09-13T05:00')}
          locale={i18n.language}
          onChange={handleDateChange(setStartDate)}
          // @ts-ignore 
          isLMS={competition?.lmsModuleProjectId}
          onCalendarOpen={() => handlePickerOpen('start')}
          onCalendarClose={() => {
            handlePickerClose();
            handleBlur(setStartDate, startDate)();
          }}
      />
    </CompetitionEditPageGridStartLabel>
  </CompetitionEditPageGridRow>, [t, isMobile, startDate, minStartDate, i18n, setStartDate])

  const endDateInput = useMemo(() => <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('end') }}>
    {/* @ts-ignore */}
    <CompetitionEditPageGridLabel isLMS={competition?.lmsModuleProjectId}>
      <FlexBox direction="column" width={200}>
        {t('competition_edit.end_date')}
        <ExamMoscowTime>  {t('competition_edit.exam_moscow_time')}</ExamMoscowTime>
      </FlexBox>
    </CompetitionEditPageGridLabel>
    {/* @ts-ignore */}
    <CompetitionEditPageGridStartLabel isLMS={competition?.lmsModuleProjectId}>
      <CustomDateTimePicker
          value={endDate}
          className="date-input"
          calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
          clearIcon={null}
          format="dd-MM-yyyy HH:mm:ss"
          maxDate={new Date('9999-09-13T05:00')}
          locale={i18n.language}
          onChange={handleDateChange(setEndDate)}
          // @ts-ignore
          isLMS={competition?.lmsModuleProjectId}
          onCalendarOpen={() => handlePickerOpen('end')}
          onCalendarClose={() => {
            handlePickerClose();
            handleEndDateBlur(setEndDate, endDate)();
          }}
      />
    </CompetitionEditPageGridStartLabel>
  </CompetitionEditPageGridRow>, [t, isMobile, endDate, startDate, i18n, setEndDate, competition])

  const modersInput = useMemo(() => <ProjectAuthorsWrapper isCompetitionEdit isCompetitions={true} direction={"column"} directionMobile={"column"}>
    <ProjectAuthorsEdit
        isCompetitions={true}
        label={t('competition_edit.moders')}
        value={competitionModerators}
        onChange={onCompetitionModeratorsChange}
        isAdminPage
    />
  </ProjectAuthorsWrapper>, [t, competitionModerators, onCompetitionModeratorsChange])

  const administratorsInput = useMemo(() => <ProjectAuthorsWrapper isCompetitionEdit isCompetitions={true} direction={"column"} directionMobile={"column"}>
    <ProjectAuthorsEdit
        isCompetitions={true}
        label={t('competition_edit.admins')}
        value={competitionAdministrators}
        canRemoveUser={competitionAdministrators?.length === 1}
        onChange={onCompetitionAdministratorsChange}
        isAdminPage
        // @ts-ignore
        isLMS={competition?.lmsModuleProjectId}
    />
  </ProjectAuthorsWrapper>, [t, competitionAdministrators, onCompetitionAdministratorsChange])

  // @ts-ignore
  const juriesInput = useMemo(() => <ProjectAuthorsWrapper  isCompetitionEdit isLMS={competition?.lmsModuleProjectId} isCompetitions={true} direction={"column"} directionMobile={"column"}>
    <ProjectAuthorsEdit
        isCompetitions={true}
        label={t('competition_edit.juries')}
        value={competitionJury}
        onChange={onCompetitionJuryChange}
        isAdminPage
        // @ts-ignore
        isLMS={competition?.lmsModuleProjectId}
        //competition={competition}
        ignoreContext
    />
  </ProjectAuthorsWrapper>, [t, competitionJury, competition, onCompetitionJuryChange])

  const enrollButtonBlock = useMemo(() => {
    return (
      <CompetitionEditPageGridRow>
        <CommonInput 
          label={t('competition_edit.enroll_button_text')}
          type={INPUT_TYPES.textarea}
          value={enrollButtonText}
          maxLength={800}
          onChange={(value: any, currentLang?: string) => setEnrollButtonText(setTextByLang(enrollButtonText, currentLang ?? 'ru', value.target.value))}
        />
      </CompetitionEditPageGridRow>
    )

  }, [enrollButtonText])

  const paidApplicationInput = useMemo(() => (
    <CompetitionEditPageGridRow isCheckbox={true}>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.paid_application')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isCheckbox={true}>
        <Input.Checkbox
            className={'competition-checkbox'}
            checked={isPaidApplication}
            title={''}
            onChange={(value: any) => setIsPaidApplication(value.target.checked)}
        />
      </CompetitionEditPageGridInput>
    </CompetitionEditPageGridRow>
  ), [isPaidApplication, t])

  const certificatesBlock = useMemo(() => {
    if (competition && competition.status === 5) {
      return (
        <CompetitionEditPageGridRow largeOffsets align="flex-start">
          <CompetitionEditPageGridLabel>
            {t('competition_edit.certificates.certificates')}
          </CompetitionEditPageGridLabel>
          <CompetitionEditPageGridInput>
            <CompetitionCertificatesBlock competition={competition}/>
          </CompetitionEditPageGridInput>
        </CompetitionEditPageGridRow>
      )
    }
  }, [competition, t])

  const longReadBlock = useMemo(() => {
    return (
      // @ts-ignore
      <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, marginBottom: 24 }} isLMS={competition?.lmsModuleProjectId}>
         {/* @ts-ignore */}
         <CompetitionEditPageGridLabel isLMS={competition?.lmsModuleProjectId}>
          {t('competition_edit.description')}
        </CompetitionEditPageGridLabel>
        <LongReadBlock
            raw={competitionLongreads}
            longReadLength={longReadLength}
            setLongReadLength={setLongReadLength}
            // @ts-ignore
            isLMSExamEdit={!!competition?.lmsModuleProjectId}
            onSetMobTextLength={handleSetMobTextLengthChange}
            toggleMobileEditor={toggleMobileEditor}
            mobileEditorAction={mobileEditorAction}
          />
       
      </CompetitionEditPageGridRow>
    )
  }, [competitionLongreads, longReadLength, handleSetMobTextLengthChange, toggleMobileEditor, mobileEditorAction])

  const AllowParticipantBlock = useMemo(() => (
    <>
      <CompetitionFixedBlock isCheckbox={true}>
        <CompetitionEditPageGridLabel>
          {t('competition_edit.allow_participant')}
        </CompetitionEditPageGridLabel>
        <CompetitionEditPageGridInput isCheckbox={true}>
          <Input.Checkbox
              className={'competition-checkbox'}
              checked={allowEmptyParticipantRequests}
              title={''}
              disabled={isPreRegistration}
              onClick={(value: any) => {
                setAllowEmptyParticipantRequests(!allowEmptyParticipantRequests)
              }}
          />
        </CompetitionEditPageGridInput>
      </CompetitionFixedBlock>
    </>), [allowEmptyParticipantRequests, isPreRegistration, t])

  if (isUpdateError) {
    return <ProjectEditFrameUpdateError id={id}/>;
  }

  if (isForbidden) {
    return <ProjectEditFrameForbidden id={id}/>;
  }

  if (isError) {
    return <ProjectEditFrameError id={id}/>;
  }

  if (isCreating) {
    return <CompetitionEditFrameCreating id={id}/>;
  }

  if (!competition || !profile || !competition.competitionId) {
    return <CompetitionEditFrameLoading id={id}/>;
  }

  // @ts-ignore
  if (competition?.lmsModuleProjectId) {
    return <>
      {PortalMenu}
      <ExamPageEdit
        juriesInput={juriesInput}
        competitionStatusInput={competitionStatusInput}
        startDateInput={startDateInput}
        endDateInput={endDateInput} competitionExamNameInput={competitionExamNameInput}
        saveButton={submitButton}
        longReadBlock={longReadBlock}
        paidApplicationInput={paidApplicationInput}
        isModer={isModer}
    /></>;
  }

  const { theme: newTheme } = createThemeByColor(userColor, theme);

  const localized_sip = (!!competition?.isBilingual && i18n.language === 'en') ? sip_en : sip

  const AutoCheckboxes = <>
    <CompetitionFixedBlock isCheckbox={true}>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.automatic')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isCheckbox={true}>
        <Input.Checkbox
            className={'competition-checkbox'}
            checked={isAutomatic}
            title={''}
            onChange={(value: any) => setIsAutomatic(value.target.checked)}
        />
      </CompetitionEditPageGridInput>
    </CompetitionFixedBlock>

    {!isBriefModer && (
      <CompetitionFixedBlock isCheckbox={true}>
        <CompetitionEditPageGridLabel>
          {'isBriefCompetition'}
        </CompetitionEditPageGridLabel>
        <CompetitionEditPageGridInput isCheckbox={true}>
          <Input.Checkbox
              className={'competition-checkbox'}
              checked={isBriefCompetition}
              title={''}
              onChange={(value: any) => handleToggleBriefCompetitionClick(value.target.checked)}
          />
        </CompetitionEditPageGridInput>
      </CompetitionFixedBlock>
    )}

    <CompetitionFixedBlock isCheckbox={true} largeOffsets>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.visibility')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isCheckbox={true}>
        <Input.Checkbox
            className={'competition-checkbox'}
            checked={competitionVisibility}
            title={''}
            onChange={(value: any) => setCompetitionVisibility(value.target.checked)}
        />
      </CompetitionEditPageGridInput>
    </CompetitionFixedBlock>

    {isAutomatic && (
        <>
          <CompetitionFixedBlock isCheckbox={true}>
            <CompetitionEditPageGridLabel>
              {t('competition_edit.ignore_main')}
            </CompetitionEditPageGridLabel>
            <CompetitionEditPageGridInput isCheckbox={true}>
              <Input.Checkbox
                  className={'competition-checkbox'}
                  checked={competitionIgnoreProjectShowcase}
                  title={''}
                  onChange={(value: any) => setCompetitionIgnoreProjectShowcase(value.target.checked)}
              />
            </CompetitionEditPageGridInput>
          </CompetitionFixedBlock>
        </>)}
  </>

  const PreRegistrationBlock = (
    <>
      <CompetitionFixedBlock isCheckbox={true}>
        <CompetitionEditPageGridLabel>
          {t('competition_edit.pre_registration')}
        </CompetitionEditPageGridLabel>
        <CompetitionEditPageGridInput isCheckbox={true}>
          <Input.Checkbox
              className={'competition-checkbox'}
              checked={isPreRegistration}
              title={''}
              disabled={!(!competitionCreativeOpen && !allowEmptyParticipantRequests) || isBriefCompetition}
              onChange={(value: any) => setIsPreRegistration(value.target.checked)}
          />
        </CompetitionEditPageGridInput>
      </CompetitionFixedBlock>
    </>)

  const DocsBlock = <>
  <CompetitionFixedBlock isCheckbox={true}>
    <CompetitionEditPageGridLabel>
      {t('competition_edit.use_form')}
    </CompetitionEditPageGridLabel>
    <CompetitionEditPageGridInput isCheckbox={true}>
      <Input.Checkbox
          className={'competition-checkbox'}
          checked={competitionCreativeOpen}
          title={''}
          disabled={isPreRegistration}
          onChange={(value: any) => setCompetitionCreativeOpen(value.target.checked)}
      />
    </CompetitionEditPageGridInput>
  </CompetitionFixedBlock>
  </>;

  const FooterBlock = <CompetitionEditPageGrid>
    {PreRegistrationBlock}
    {AllowParticipantBlock}
    {DocsBlock}
    {AutoCheckboxes}

  <CompetitionFixedBlock>
    <ColorPicker
      isCompetition={true}
      value={userColor}
      onChange={(color) => setUserColor(color)}
    />
  </CompetitionFixedBlock>

  {isMobile && (
    <CompetitionEditPageGridRow>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.docs')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput>
        <Select
            placeholder={t('competition_edit.select')}
            isClearable
            isMulti
            className={'competition-select-input'}
            classNamePrefix={'competition-select'}
            options={competitionDocumentOptions}
            value={competitionDocuments}
            onChange={(item: any) => setCompetitionDocuments(item)}
        />
      </CompetitionEditPageGridInput>
    </CompetitionEditPageGridRow>
    )}


  <CompetitionFixedBlock offsetBottom={56}>
    <CompetitionEditPageGridLabel></CompetitionEditPageGridLabel>
    <BilingualSwitcher isBilingual={isBilingual} onClick={handleToggleBilingualClick} isCompetitionEdit/>
  </CompetitionFixedBlock>

        <FlexBox direction="column" directionMobile="column" offsetBottom={isMac13 ? 40 : 56} offsetBottomMobile={40}>
          <LangTitleBox title={t('competition_edit.labels.tags')} mainTitle={true} isCompetitionEdit />

          {requiredTagsInput}
          {regularTagsInput}
          {excludingTagsInput}

        </FlexBox>

    {criteriasBlock}
    <CompetitionEditPageGridRow style={{marginBottom: '24px'}} isCheckbox={true} largeOffsets>
     
      {tabsData.map((tab, index) => {
                
                if(tab.tabId === '1'){
                  const name = tab.name
                  return (
                    <>
                    <CommonInput 
                      type={INPUT_TYPES.text}
                        maxLength={25}
                        value={!!name ? name : ''}
                        placeholder={t(`competition.tabs.${CUSTOMTABS[tab.tabId]}`)}
                        label={t('competition_edit.show_about')}
                        //@ts-ignore
                        onChange={(ev, currentLang?: string) => onTabNameChange(ev?.target?.value, tab?.position, currentLang)}
                    />
                    </>
                );
                }
              })}
    </CompetitionEditPageGridRow>
  <LangTitleBox title={t('competition_edit.labels.jury')} mainTitle isCompetitionEdit />
  <CompetitionEditPageGridRow isCheckbox={true} largeOffsets>
  
      {tabsData.map((tab, index) => {
            
                if(tab.tabId === '2'){
                  const currentLang = tab?.currentLang || 'ru';
                  const name = Lang(tab.name, currentLang);             
                  return (
                    <>
                      <CompetitionEditPageGridLabel fullSize>
                        <LangTitleBox 
                          title={t('competition_edit.show_jury')} 
                          mainTitle={false} 
                          onLangChange={() => onLocalLangChanges(tabsData, currentLang, tab.tabId, (val) => setTabsData(val))} 
                          lang={currentLang} 
                          isCompetitionEdit
                          />
                      </CompetitionEditPageGridLabel>
                      <CompetitionEditPageGridInput isCheck isCheckbox={true}>
                          <Input.Checkbox
                              className={'competition-checkbox'}
                              checked={tab.enable}
                              title={''}
                              onChange={(value: any) => onTabCheckboxChange(value.target.checked, tab?.position)}
                          />
                      </CompetitionEditPageGridInput>
                      <CommonInput 
                        type={INPUT_TYPES.text}
                        maxLength={14}
                        value={!!name ? name : ''}
                        placeholder={t(`competition.tabs.${CUSTOMTABS[tab.tabId]}`)}
                        //@ts-ignore
                        onChange={(ev) => onTabNameChange(ev?.target?.value, tab?.position, currentLang)}
                      />
                    </>
                );
                }
              })}
    </CompetitionEditPageGridRow>
    {administratorsInput}
    {modersInput}
    {juriesInput}

    <CompetitionEditPageGridRow>
      <CommonInput 
        type={INPUT_TYPES.textarea}
        orientation="row"
        label={t('competition_edit.enter_text')}
        maxLength={800}
        value={Lang(competitionJuryText, i18n.language)}
        onChange={(value: any) => onCompetitionJuryTextChange(value.target.value)}
      />
    </CompetitionEditPageGridRow>
    <CompetitionEditPageGridRow>
      <CommonInput 
        type={INPUT_TYPES.text}
        orientation="row"
        value={competitionLink}
        label={t('competition_edit.link')}
        placeholder={t('create.title_info.link_format')}
        onChange={(value: any) => {
          setCompetitionLink(value.target.value)
        }}
      />
    </CompetitionEditPageGridRow>

    <CompetitionEditPageGridRow>
      <CommonInput 
        type={INPUT_TYPES.text}
        orientation="row"
        label={t('competition_edit.max_participants')}
        placeholder={t('create.title_info.participants_count')}
        value={maxParticipantsCount}
        onChange={({ target }: any) => {
          const reg = /[\D]/g;
          const val = target.value;
          if ((Number(val) === 0 && val !== '') || val.match(reg)) {
            toasts.error(t(`competition_edit.frames.wrong_symbols`))
            return;
          }
          if (!allowedMaxCount(Number(val), MAX_PARTICIPANTS_COUNT)) {
            toasts.error(t(`competition_edit.frames.max_participants`, { count: MAX_PARTICIPANTS_COUNT }))
            return;
          }

          setMaxParticipantsCount(val)
        }}
      />
    </CompetitionEditPageGridRow>
    {isBriefCompetition && (
      <CompetitionEditPageGridRow>
        <CommonInput 
          type={INPUT_TYPES.dropdown}
          orientation="row"
          label={t('competition_edit.flow_number')}
          value={briefCompetitionFlow}
          options={fabricFlowOpts.map(item => ({...item, label: t(`competition_edit.designFabricForm.flows.label.${item.label}`)}))}
          onChange={(item: any) => setBriefCompetitionFlow(item)}
        />
      </CompetitionEditPageGridRow>
    )}

<FlexBox direction="column" directionMobile="column" offsetTop={isMac13 ? 40 : 56} offsetTopMobile={40}>
    <LangTitleBox title={t('competition_edit.labels.winners')} mainTitle isCompetitionEdit />                        
    <CompetitionEditPageGridRow isCheckbox={true} largeOffsets>
    
      {tabsData.map((tab, index) => {
                if(tab.tabId === '3'){
                  const currentLang = tab?.currentLang || 'ru';
                  const name = Lang(tab.name, currentLang);
                  
                  return (
                    <>
                    <CompetitionEditPageGridLabel fullSize>
                      <LangTitleBox 
                        title={t('competition_edit.show_all_projects')} 
                        mainTitle={false} 
                        onLangChange={() => onLocalLangChanges(tabsData, currentLang, tab.tabId, (val) => setTabsData(val))} 
                        lang={currentLang} 
                        isCompetitionEdit
                                  />
                    </CompetitionEditPageGridLabel>
                    <CompetitionEditPageGridInput isCheck isCheckbox={true}>
                                    <Input.Checkbox
                                        className={'competition-checkbox'}
                                        checked={tab.enable}
                                        title={''}
                                        onChange={(value: any) => onTabCheckboxChange(value.target.checked, tab?.position)}
                                    />
                    </CompetitionEditPageGridInput>
                    <CommonInput 
                      type={INPUT_TYPES.text}
                      maxLength={14}
                      value={!!name ? name : ''}
                      placeholder={t(`competition.tabs.${CUSTOMTABS[tab.tabId]}`)}
                      //@ts-ignore
                      onChange={(ev) => onTabNameChange(ev?.target?.value, tab?.position, currentLang)}
                    /> 
                  </>
                );
                }
              })}
    </CompetitionEditPageGridRow>
    <CompetitionEditPageGridRow isCheckbox={true} largeOffsets>
      
      {tabsData.map((tab, index) => {
                if(tab.tabId === '4'){
                  const currentLang = tab?.currentLang || 'ru';
                  const name = Lang(tab.name, currentLang);
                  return (
                    <>
                    <CompetitionEditPageGridLabel fullSize>
                      <LangTitleBox 
                        title={t('competition_edit.show_short_list')} 
                        mainTitle={false} 
                        onLangChange={() => onLocalLangChanges(tabsData, currentLang, tab.tabId, (val) => setTabsData(val))} 
                        lang={currentLang} 
                        isCompetitionEdit
                        />
                    </CompetitionEditPageGridLabel>
                     <CompetitionEditPageGridInput isCheck isCheckbox={true}>
                     <Input.Checkbox
                        className={'competition-checkbox'}
                        checked={showShortList}
                        title={''}
                        onChange={(value: any) => {
                          onTabCheckboxChange(value.target.checked, tab?.position)
                          setShowShortList(value.target.checked)
                        }}
                       />
                      </CompetitionEditPageGridInput>
                      <CommonInput 
                        type={INPUT_TYPES.text}
                        maxLength={14}
                        value={!!name ? name : ''}
                        placeholder={t(`competition.tabs.${CUSTOMTABS[tab.tabId]}`)}
                        //@ts-ignore
                        onChange={(ev) => onTabNameChange(ev?.target?.value, tab?.position, currentLang)}
                      />
                    </>
                );
                }
              })}
    </CompetitionEditPageGridRow>

    {winnerTextBlock}

    <CompetitionEditPageGridRow largeOffsets align={!winnerPositions?.length ? 'center' : "start"}  alignMobile={!winnerPositions?.length ? 'center' : "start"} style={{ alignItems: !isMobile ? (!winnerPositions?.length ? 'center' : "start") : 'start'}} isWinners>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.winners')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isChoose={true}>
        <ShortListWinnerProjectsEdit
            competitionId={competition.competitionId}
            projects={winnerPositions}
            onSetProjects={onSetWinnerPostitions}
            onRebuildProjects={rebuildWinnerPositions}
            onSort={onSortWinners}
            onSetPosition={onSetWinnerPosition}
            draggable={!is744BP}
            >
        </ShortListWinnerProjectsEdit>
      </CompetitionEditPageGridInput>
    </CompetitionEditPageGridRow>

    {winnerFinalTextBlock}
    {enrollButtonBlock}

    <CompetitionEditPageGridRow offsetBottomMobile={!finalistsID?.length ? 16 : 0} isChoose={true} largeOffsets align={!finalistsID?.length ? 'center' : "start"} alignMobile={!finalistsID?.length ? 'center' : "start"} style={{ alignItems: !isMobile ? (!finalistsID?.length ? 'center' : "start") : 'start' }}>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.finalists')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isChoose={true}>
        <ShortListProjectsEdit
            competitionId={competition.competitionId}
            projectIds={finalistsID}
            draggable={!is744BP}
            onSetProjects={(data: any) => setFinalistsID(data?.reverse())}>
        </ShortListProjectsEdit>
      </CompetitionEditPageGridInput>
    </CompetitionEditPageGridRow>

    {certificatesBlock}

    </FlexBox>
  </CompetitionEditPageGrid>

  

  return (
    <ThemeProvider theme={newTheme as any}>
      <CustomBgWrapper backgroundColor={userColor}>
        <GlobalColoring color={userColor} brighter={brighter} darker={darker}/>
        <PageViewportLayout vtype={vtype} style={{ marginTop: is744BP ? 10 : isMobile ? 0 : 14 }}>
          {PortalMenu}

          <ProjectContainerLayout
              isCompetitionEdit={true}
            leftSide={
              <LeftSide
                isCompetitionEdit={true}
                project={competitionTitleImages}
                customProps={custom}
                userColor={userColor}
                // @ts-ignore
                fileInput={localized_sip}
              />
            }
            rightSide={(
              <CompetitionEditPageContainer>
                <ProjectTitleSection
                  isCompetitionEdit={true}
                  customProps={custom}
                  projectTitle={Lang(competitionName, i18n.language)}
                  setProjectTitle={onCompetitionNameChange}
                />

                <CompetitionEditPageGridRow direction="column" >
                  <FlexBox direction={'row'} width={'100%'} gx={8}>
                    <CommonInput
                      type={INPUT_TYPES.text}
                      orientation="row"
                      label={t('competition_edit.context')}
                      value={competitionContextText}
                      onChange={(ev: any) => allowedCharacters(ev, setCompetitionContextText)}
                      // resultComponent={
                      //   <ContextsSection value={competitionContexts} onClick={onDeleteContext} />
                      // }
                    />
                    {!!competitionContextText?.length && (
                      <FlexBox>
                      <DefaultButton wh={50} whMob={50} onClick={() => {
                        if (!competitionContexts.includes(competitionContextText)) {
                          setCompetitionContexts([...competitionContexts, competitionContextText]);
                          if (competitionContextText === COMPETITIONS_CONTEXTS.briefs) {
                            setIsBriefCompetition(true);
                          }
                        }
                        setCompetitionContextText('');
                      }}>+</DefaultButton>

                      </FlexBox>
                    )}
                  </FlexBox>    
                    <ContextsSection value={competitionContexts} onClick={onDeleteContext} />
                </CompetitionEditPageGridRow>

                <CompetitionEditPageGridRow direction="column" >
                  <CommonInput
                    type={INPUT_TYPES.dropdown}
                    label={t('competition_edit.status')}
                    options={STATUSES_List.map(item => ({...item, label: t('competition.statuses.'+item.label)})) as any}
                    value={competitionStatus as any}
                    onChange={(item: any) => setCompetitionStatus(item)}
                  />
                </CompetitionEditPageGridRow>


                <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('start') }}>
                  <CompetitionEditPageGridLabel>
                    {t('competition_edit.start_date')}
                    <LabelRedStar>*</LabelRedStar>
                  </CompetitionEditPageGridLabel>
                  <CompetitionEditPageGridStartLabel>
                    <CustomDateTimePicker
                        value={startDate}
                        className="date-input"
                        calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
                        clearIcon={<CloseIconSmall />}
                        format="dd-MM-yyyy HH:mm:ss"
                        maxDate={new Date('9999-09-13T05:00')}
                        locale={i18n.language}
                        onChange={handleDateChange(setStartDate)}
                        onCalendarOpen={() => handlePickerOpen('start')}
                        onCalendarClose={() => {
                          handlePickerClose();
                          handleCompetitionBlur(setStartDate, startDate)();
                        }}
                        disableClock={true}
                        
                    />
                  </CompetitionEditPageGridStartLabel>
                </CompetitionEditPageGridRow>

                <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('tech') }}>
                  <CompetitionEditPageGridLabel>
                    {t('competition_edit.end_date_tech')}
                    <LabelRedStar>*</LabelRedStar>
                  </CompetitionEditPageGridLabel>
                  <CompetitionEditPageGridStartLabel>
                    <CustomDateTimePicker
                        value={endDate_Internal}
                        className="date-input"
                        calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
                        clearIcon={<CloseIconSmall />}
                        format="dd-MM-yyyy HH:mm:ss"
                        maxDate={new Date('9999-09-13T05:00')}
                        locale={i18n.language}
                        onChange={handleDateChange(setEndDate_Internal)}
                        onCalendarOpen={() => handlePickerOpen('tech')}
                        onCalendarClose={() => {
                          handlePickerClose();
                          handleEndDateBlur(setEndDate_Internal, endDate_Internal)();
                        }}
                        disableClock={true}
                    />
                  </CompetitionEditPageGridStartLabel>
                </CompetitionEditPageGridRow>

                <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('end') }}>
                  <CompetitionEditPageGridLabel>
                    {t('competition_edit.end_date')}
                    <LabelRedStar>*</LabelRedStar>
                  </CompetitionEditPageGridLabel>
                  <CompetitionEditPageGridStartLabel>
                    <CustomDateTimePicker
                        value={endDate}
                        className="date-input"
                        calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
                        clearIcon={<CloseIconSmall />}
                        format="dd-MM-yyyy HH:mm:ss"
                        maxDate={new Date('9999-09-13T05:00')}
                        locale={i18n.language}
                        onChange={handleDateChange(setEndDate)}
                        onCalendarOpen={() => handlePickerOpen('end')}
                        onCalendarClose={() => {
                          handlePickerClose();
                          handleEndDateBlur(setEndDate, endDate)();
                        }}
                        disableClock={true}
                        
                    />
                  </CompetitionEditPageGridStartLabel>
                </CompetitionEditPageGridRow>
               
                  {!isMobile && (
                    <CompetitionEditPageGridRow>
                     <CompetitionEditPageGridLabel>
                       {t('competition_edit.docs')}
                     </CompetitionEditPageGridLabel>
                     <CompetitionEditPageGridInput>
                        <Select
                            placeholder={t('competition_edit.select')}
                            isClearable
                            isMulti
                            className={'competition-select-input'}
                            classNamePrefix={'competition-select'}
                            options={competitionDocumentOptions}
                            value={competitionDocuments}
                            onChange={(item: any) => setCompetitionDocuments(item)}
                        />
                      </CompetitionEditPageGridInput>
                    </CompetitionEditPageGridRow>
                  )}
                  {isRating && (
                    <CommonInput 
                      type={INPUT_TYPES.text}
                      value={editContextText}
                      disable
                      label={t('competition_edit.project_context')}
                      onChange={(ev: any) => setEditContextText(ev.target.value)}
                    />
                  )}


                {is744BP && FooterBlock}

                {is744BP && (
                    <LongReadBlock
                        raw={competitionLongreads}
                        longReadLength={longReadLength}
                        setLongReadLength={setLongReadLength}
                    />
                )}

              </CompetitionEditPageContainer>
            )}
            footer={!is744BP ? FooterBlock : undefined}
          />

          {!is744BP && (
            <LongReadBlock
              raw={competitionLongreads}
              longReadLength={longReadLength}
              setLongReadLength={setLongReadLength}
            />
          )}

          <FlexBox offsetTop={200} offsetTopMobile={40} />
        </PageViewportLayout>
      </CustomBgWrapper>
      <ScrollUpZone/>
    </ThemeProvider>
  );
}

export default CreateCompetitionPage;// TODO: проверить
import { API, Competition, CompetitionAPI, Designer, DocumentAPI, Endpoints, Lang, Project, Tag } from "@brg/api";
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { ProfileRole, bProfile, useProfile } from "@brg/auth";
import { Input } from "@brg/input";
import {Colors, CommonInput, DropdownListItem, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile, useToasts} from "@brg/ui";
import { useSimpleUploader } from "@brg/uploader";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {bArray, bTag, LayoutConst, useModal} from "core";
import { BTag } from "core/components";
import { bColor } from "core/utils/bColor";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import {ReactComponent as DottedIcon } from 'shared/pages/teams/handle.svg';
import { ProjectEditFrameError, ProjectEditFrameForbidden, ProjectEditFrameUpdateError } from "shared/components/error-frames";
import { NavbarCreate } from "shared/components/navbar-elements";
import { PageViewportLayout, ProjectContainerLayout } from "shared/components/template";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { ScrollUpZone } from "shared/components/__FOX__/NAV/src/scroll-up-zone";
import { CreateLinkTo } from "shared/constants/linkTo";
import { createThemeByColor } from "shared/helpers/coloring";
import ColorPicker, { WIDE_SCREEN_COLORS } from "shared/pages/projectEdit/components/ColorPicker/ColorPicker";
import LeftSide from "shared/pages/projectEdit/LeftSide";
import LongReadBlock from "shared/pages/projectEdit/LongReadBlock";
import ProjectAuthorsEdit, { ProjectAuthorsChangeCbT } from "shared/pages/projectEdit/ProjectAuthorsEdit";
import ProjectTitleSection from "shared/pages/projectEdit/ProjectTitleSection";
import { GlobalColoring, ProjectAuthorsWrapper, ProjectEditPageContainer, ProjectEditPageGrid, ProjectEditPageGridLabel, ProjectEditPageGridRow, ProjectEditPageGridStartLabel } from "shared/pages/projectEdit/styles";
import { AuthorT, LongreadMobileActions } from "shared/pages/projectEdit/types";
import { convertDesignerFromGlobalToLocal } from "shared/pages/projectEdit/utils";
import { setType } from "shared/reducers/ViewTypeSlice";
import styled, {css, ThemeProvider, useTheme} from "styled-components";
import { STATUSES, STATUSES_List } from "_competition/const";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { ShortListProjectsEdit } from "./Components/ShortListProjects/ShortListProjectsEdit";
import { Counter, CriteriaWrapper, SortableWrapper } from "./styles";
import { Date24Icon } from "shared/components/tagAdminProjectsSearchBar/date24";
import { Date32Icon } from "shared/components/tagAdminProjectsSearchBar/date32";
import 'shared/components/tagAdminProjectsSearchBar/styles.css';
import DateTimePicker from "react-datetime-picker";
import {CustomBgWrapper} from "../../../shared/components/CustomBgWrapper/CustomBgWrapper";
import PlusIconThin from "../../../shared/icons/PlusIconThin";
import { ShortListWinnerProjectsEdit } from "./Components/ShortListProjects/ShortListWinnerProjectsEdit";
import { DefaultButton, TableSortWrapper } from "../../../shared/pages/teams/styles";
import { allowedCharacters, allowedMaxCount, setTextByLang } from "../../../shared/pages/teams/TeamEdit";
import { BasketIcon } from "../../../shared/pages/projectEdit/BasketIcon";
import { CompetitionEditFrameCreating, CompetitionEditFrameLoading } from "shared/components/error-frames/competition-edit-frames";
import { LangTitleBox } from "shared/components/LangTitleBox/LangTitleBox";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { computeDataWithLang } from "shared/helpers/types/computed/ComputedTeam";
import {ReactComponent as PlusSvg } from "shared/pages/projectEdit/close.svg";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import { slicedKey } from "shared/actions/infinityProjectsActions";
import { useToggleBilingual } from "shared/hooks/useToggleBilingual";
import { ContextsSection } from "./sections/ContextsSections/ContextsSection";
import { BilingualSwitcher } from "shared/components/BilingualSwitcher/BilingualSwitcher";
import { HsePolicies } from "shared/constants/HsePolicies";
import { COMPETITIONS_CONTEXTS } from "../AllCompetitionsPage/const/competitionContexts";
import { FABRIC_FLOW, fabricFlowOpts } from "shared/pages/DesignFabric/components/FlowDropdown";
import {ExamPageEdit} from "../../../shared/pages/examPage/examPageEdit";
import {ButtonFilled, LabelRedStar} from "../../../shared/pages/designerEditView/styles";
import { CUSTOMTABS } from "shared/pages/opencallsPage/GetCompetitionItem/GetCompetitionItem";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { Criteria } from "@brg/api/dist/api-core/classes/CompetitionAPI";
import { Voidable } from "@brg/toolbox";
import { CompetitionCertificatesBlock } from "./Components/CompetitionCertificatesBlock";
import CloseIconSmall from "shared/icons/CloseIconSmall";

const MIN_CRITERIA_COUNT = 5;
const MAX_CRITERIA_COUNT = 10;
const DEFAULT_PARTICIPANTS_COUNT = 0;
const MAX_PARTICIPANTS_COUNT = 1000;

const COMPETITION_LINK_REG = /^https?:\/\/.+$/;
interface ICompetitionEditPageProps {
  className?: any;
}

const CompetitionEditPageGridRow = styled(ProjectEditPageGridRow)<{isChoose?: boolean, largeOffsets?: boolean, isWinners?: boolean, largeOffset?: boolean, isLMS?: boolean}>`
  margin-top: ${({ largeOffsets }) => largeOffsets ? '32px' : '24px'} !important;
  // align-items: center;

  // .react-datetime-picker__inputGroup__leadingZero, .react-datetime-picker__inputGroup__divider {
  //   color: #151514;
  // }

  ${DropdownListItem} {
  
  }

  .brg-input__indicators {
    justify-content: center;
    display: flex;
    height: 48px;
    max-height: 48px;
    .brg-input__indicator {
      padding: 0;
      height: 40px;
      max-height: 40px;
  
      svg {
        padding: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: ${({ largeOffsets }) => largeOffsets ? '24px' : '16px'};

    input {
      height: 40px !important;
    }

    .brg-input__indicators {
      height: 40px;
      max-height: 40px;
      .brg-input__indicator {
        height: 40px;
        max-height: 40px;
      }
    }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: ${({ largeOffset }) => largeOffset ? '32.2px' : '24px' } !important;
    flex-direction: ${({isCheckbox, isChoose}) => isChoose ? 'row' : isCheckbox ? 'row-reverse' : 'column'};
    align-items: ${({isCheckbox, isChoose}) => (isCheckbox || isChoose) ? 'center' : 'flex-start'};
    justify-content: ${({isCheckbox}) => isCheckbox ? 'flex-end' : 'flex-start'};
    row-gap: 8px;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 16px!important;
    flex-direction: ${({isCheckbox}) => isCheckbox ? 'row-reverse' : 'column'};
    align-items: ${({isCheckbox}) => isCheckbox ? 'center' : 'flex-start'};

  }
`;


export const CompetitionFixedBlock = styled(CompetitionEditPageGridRow)<{ disableOffset?: boolean }>`
  max-width: ${LayoutConst.projectCover.l.w}px;

  ${({ disableOffset }) => disableOffset && css`
    margin-top: 0 !important;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: ${LayoutConst.projectCover.m.w}px;
  }
`;

export const CriteriaMaxValueLabel = styled(FlexBox)`
  font-size: 15px;
  line-height: 20xp;
  color: #909090;
`;

export const CompetitionEditPageGridLabel = styled(ProjectEditPageGridLabel)<{isAuthorSelect?: boolean, fullSize?: boolean, isLMS?: boolean, nowrap?: boolean}>`
  margin-right: 24px;
  width: 224px;
  min-width: 224px;
  padding-top: 0;
  color: ${({ theme }) => theme.competition.label.color};

  ${({ nowrap }) => nowrap && css` white-space: nowrap`};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-right: 16px;
    width: 160px;
    min-width: 160px;
    ${({ isLMS }) => isLMS ? css`
      max-width: 160px;
      font-size: 13px;
      line-height: 16px;
    ` : null};

  ${({ fullSize }) => fullSize && css`
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
      min-width: none;
    }
  `}

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: ${({isAuthorSelect}) => isAuthorSelect ? 8 : 0}px;
  }

`
const CompetitionEditPageGridStartLabel = styled(ProjectEditPageGridStartLabel)<{isLMS?: boolean}>`
  margin-right: 0;
  padding-top: 0;
  width: 100%;
  height: 48px;
  margin-bottom: ${({isLMS}) => isLMS ? 0 : 8}px;

  .date-input {
    width: 100%!important;
    max-width: 100% !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%
  }
`

const ButtonText = styled.div`
  color: ${({theme}) => theme.competition.input.secondText};
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  letter-spacing: -0.02em;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const AddTagsWrapper = styled(FlexBox)<{isEmpty?: boolean}>`
  width: 100%;
  height: 32px;
  border: 1px solid ${({theme}) => theme.competition.input.checkbox.border};
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  column-gap: 12px;
  margin-bottom: ${({isEmpty}) => isEmpty ? '0' : '24px'};
  
  svg {
    width: 15px;
    height: 15px;
    path {
      fill: ${({theme}) => theme.competition.input.inputText};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-bottom: ${({isEmpty}) => isEmpty ? '0' : '16px'};
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 16px);
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
  }
`

export const CompetitionContentAddContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  .tags-wrapper-grid-block {
    max-width: 100%;
    margin-top: 16px;
    margin-left: 0;

    * {
      margin-left: 0;
    }
  }
`

const CompetitionEditPageGrid = styled(ProjectEditPageGrid)`
  width: ${LayoutConst.projectContainer.l}px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${LayoutConst.projectContainer.m}px;
    margin-top: 8px;
  }
  
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 32px);
    margin: 0px 16px 0px;
    height: auto;
  }
  
  @media (max-width: ${LayoutConst.screen.s -1}px) {
    width: 100%;
    margin: 0;
  }
`

const CompetitionEditPageContainer = styled(ProjectEditPageContainer)`


  @media (max-width: ${LayoutConst.screen.md}px) {
    padding: 0;
    margin: 0;
  }

  input, .brg-input__control, .competition-select__control {
    height: 48px !important;
    max-height: 48px !important;
    min-height: 48px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 40px !important;
      max-height: 40px !important;
      min-height: 40px !important;

      .brg-input__indicator, .brg-input__dropdown-indicator {
        padding: 0;
      }
    }
  }

  .competition-select__value-container {
    height: 100%:
  }

  .bilingual-container {

    @media (max-width: ${LayoutConst.screen.s -1}px) {
      flex-flow: column;
    }
  }
`

const CompetitionEditPageGridInput = styled(ProjectEditPageGridInput)<{isChoose?: boolean, isLMS?: boolean, isCheck?: boolean}>`
  .competition-select__input {
    display: none !important;
  }
  
  .brg-input__control {
    background-color: ${({theme}) => theme.competition.input.bg} !important;
    border: 1px solid ${({theme}) => theme.competition.input.bg} !important;
    cursor: pointer;

    .brg-input__single-value, .brg-input__placeholder,
    .brg-input__placeholder:hover, .brg-input__single-value:hover {
      color: ${({theme}) => theme.competition.input.inputText} !important;
      border: 1px solid ${({theme}) => theme.competition.input.bg} !important;
    }
    ${({isLMS}) => isLMS && css`
     .brg-input__single-value, .brg-input__placeholder,
      .brg-input__placeholder:hover, .brg-input__single-value:hover {
        color: ${({theme}) => theme.competition.input.mainText} !important;
    }

  `}

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }
  }

  .brg-input__menu-list {
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({theme}) => theme.competition.input.inputText} !important;
    }
  }

  .brg-input__menu {
    background-color: ${({theme}) => theme.competition.input.bg} !important;

    .brg-input__option {
      cursor: pointer;
      color: ${({theme}) => theme.competition.input.inputText} !important;
      svg {
        path {
          fill: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    }
    .brg-input__option--is-focused {
      background-color: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    .brg-input__option--is-focused:hover {
      background-color: ${({theme}) => theme.competition.input.bgActive} !important;
    }
  }
  
  .brg-input__indicator {
    margin-right: 0;
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.inputText} !important;;
      }
    }
  }

  button {
    border: 1px solid ${({theme}) => theme.competition.input.button.border};
    background-color: ${({theme}) => theme.competition.input.button.bg};
    color: ${({theme}) => theme.competition.input.mainText};
    border-radius: 3px;
    padding: 8px 36px;
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      width: 100%;
    }
  }

  .globalTypes {
    color: ${({theme}) => theme.competition.input.mainText} !important;
  }

 .competition-select__control {
   background-color: ${({theme}) => theme.competition.input.bg};
   border: none;
   border-radius: 3px;
   cursor: pointer;
   height: 48px;

   @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
     height: 40px;
   }
 }
 .competition-select__menu-list {
   background-color: ${({theme}) => theme.competition.input.bg}!important;
   color: ${({theme}) => theme.competition.input.inputText}!important;
 }
 .competition-select__menu {
   background-color: ${({theme}) => theme.competition.input.bg}!important;
   color: ${({theme}) => theme.competition.input.inputText}!important;
 }
 .competition-select__option {
   background-color: ${({theme}) => theme.competition.input.bg}!important;
   color: ${({theme}) => theme.competition.input.inputText}!important;
   cursor: pointer!important;
 }
  .competition-select__indicator-separator {
    display: none;
  }
  .competition-select__value-container {
    padding: 2px 16px;
    height: 100%;
  }
  .competition-select__indicator {
    align-items: center;
    width: 40px;
    height: 40px;
    color: ${({theme}) => theme.competition.secondaryText} !important;
  }
  
  input ~ .competition-checkbox {
    
    width: 24px;
    height: 24px;
    background: ${({theme}) => theme.competition.input.checkbox.bg} !important;
    border-color: ${({theme}) => theme.competition.input.checkbox.border} !important;
    
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.checkbox.icon};
      }
    }
  }
  
  input.competition-checkbox {
    
    width: 24px!important;
    height: 24px!important;
  }
  
  ${({isCheckbox}) => isCheckbox && css`
    width: fit-content;
  `}

  ${({isCheck}) => isCheck && css`
    align-items: flex-start;
    margin-top: 7px;
  `}
`

export const CustomDateTimePicker = styled(DateTimePicker)<{isLMS?: boolean, isFormPage?: boolean}>`

  .react-calendar {
    background: ${({theme}) => theme.competition.input.bg};
    border: none;
    .react-calendar__tile--now {
      background-color: ${({theme}) => theme.competition.input.date.bgNow} !important;
      color: ${({theme}) => theme.competition.input.date.colorNow} !important;
    }
    .react-calendar__tile--active {
      background-color: ${({theme}) => theme.competition.input.date.bgActive} !important;
      color: ${({theme}) => theme.competition.input.date.colorActive} !important;
    }
  }

  .react-calendar__year-view {
    .react-calendar__year-view__months__month {
      color: ${({ theme }) => theme.competition.secondaryText} !important;
    }
  }

  .react-datetime-picker__inputGroup {


    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute,
    .react-datetime-picker__inputGroup__second {
      outline: none;
      color: ${({theme}) => {
        return theme.competition.secondaryText}} !important;
    }
    ${({isLMS}) => isLMS && css`
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute {
      color: #151514 !important;
    }
  `}
    ${({isFormPage}) => isFormPage && css`
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider,
    .react-datetime-picker__inputGroup__hour,
    .react-datetime-picker__inputGroup__minute {
      color: #151514 !important;
      font-size: 13px !important;
      line-height: 16px !important;
    }
  `}

  }
  
  .react-datetime-picker__inputGroup__input {
    color: ${({theme}) => theme.competition.secondaryText} !important;
  }

  .react-datetime-picker__wrapper {
    border: none;
    border-radius: 3px;
    padding: 0 16px;
    background-color: ${({theme}) => theme.competition.input.bg};
    
    svg {
      path {
        
        fill: ${({theme}) => theme.competition.secondaryText};
      }
    }
  }
`
const ExamMoscowTime = styled.div`
  font-size: 12px;
`
interface Language {
  lang: string;
  name: string;
}

interface Tab {
  name: Language[];     
  position: number;       
  enable: boolean;        
  currentLang: string; 
  tabId: string;   
}
const DEFAULTTABS: Tab[] = [
  {
    name: [{ lang: 'en', name: 'About Competition' }, { lang: 'ru', name: 'О конкурсе' }],
    position: 1,
    enable: false,
    currentLang: "ru",
    tabId: '1'

  },
  {
    name: [{ lang: 'en', name: 'Jury' }, { lang: 'ru', name: 'Жюри' }],
    position: 2,
    enable: false,
    currentLang: "ru",
    tabId: '2' 
  },
  {
    name: [{ lang: 'en', name: 'Projects' }, { lang: 'ru', name: 'Проекты' }],
    position: 3,
    enable: false,
    currentLang: "ru",
    tabId: '3' 
  },
  {
    name: [{ lang: 'en', name: 'Shortlist' }, { lang: 'ru', name: 'Шорт-лист' }],
    position: 4,
    enable: false,
    currentLang: "ru",
    tabId: '4' 
  }
];
const defaultCompetitionName = [
  {
      lang: "Ru",
      name: ""
  },
  {
      lang: "En",
      name: ""
  }
]


const fixTimezoneOffsetToShow = (date: Date | undefined) : Date | undefined => {
  if(!date) return undefined;
  return new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
}
const fixTimezoneLMSExamShow = (date: Date | undefined): Date | undefined => {
  if (!date) return undefined;

  const localDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
  const mskOffset = 3 * 60 * 60 * 1000;
  return new Date(localDate.getTime() + mskOffset);
};

const fixTimezoneOffsetToSave = (date: Date | undefined) : Date | undefined => {
  if(!date) return undefined;
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
}
const fixTimezoneLMSExam = (date: Date | undefined): Date | undefined => {
  if (!date) return undefined;

  const mskOffset = 3 * 60 * 60 * 1000; 
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000) - mskOffset);
};

const TagsWrapper: FC<{children: JSX.Element[], isExam: any}> = ({children, isExam}) => {

  if (isExam) return <CompetitionEditPageGridRow largeOffsets align="flex-start">{children}</CompetitionEditPageGridRow>

  return <CompetitionFixedBlock align="flex-start" className={'tags-wrapper'}>{children}</CompetitionFixedBlock>

}

const setCompetitionStringValueByLang = (
  isBilingual: boolean,
  currentValue: LangObject[],
  lang: string,
  value: string
): LangObject[] => {
  if (isBilingual) {
    const engValue = currentValue.find(({ lang }) => lang.toLowerCase() === 'en')!
    const ruValue = currentValue.find(({ lang }) => lang.toLowerCase() === 'ru')!
    if (lang.toLowerCase() === 'ru') {
      return [{
        lang: 'ru',
        name: value,
      }, engValue];
    } else {
      return [ruValue, {
        lang: 'en',
        name: value,
      }]
    }
  } else {
    return createDefaultLangObject(value);
  }
}

const CreateCompetitionPage: FC<ICompetitionEditPageProps> = ({ className }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const toasts = useToasts();
  const profile = useProfile();
  const isMobile = useIsMobile();
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const history = useHistory();
  const theme = useTheme();
  const modal = useModal();
  const { id } = useParams<{ id: string }>();
  const competitionIdRef = useRef<any>(null);
  const langRef = useRef<any>(null);
  const bilingualRef = useRef<any>(null);
  const sipRef = useRef<any>(null);
  const sipRefEn = useRef<any>(null);
  const throttle = useRef<any>();
  const [time, setTime] = useState(Date.now());
  const [isCreating, setIsCreating] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isForbidden, setIsForbidden] = useState(false);
  const [isUpdateError, setIsUpdateError] = useState(false);
  const [competition, setCompetition] = useState<Competition<'Global'> | undefined>();
  const [competitionName, setCompetitionName] = useState<LangObject[]>(defaultCompetitionName);
  const [competitionAdministrators, setCompetitionAdministrators] = useState<AuthorT[]>([]);
  const [competitionModerators, setCompetitionModerators] = useState<Designer<'Local'>[]>([]);
  const [competitionJury, setCompetitionJury] = useState<Designer<'Local'>[]>([]);
  const [competitionJuryText, setCompetitionJuryText] = useState<LangObject[]>([]);
  const [competitionVisibility, setCompetitionVisibility] = useState<boolean>(false);
  const [competitionIgnoreProjectShowcase, setCompetitionIgnoreProjectShowcase] = useState<boolean>(false);
  const [competitionStatus, setCompetitionStatus] = useState<{ label: string; value: number; }>();
  const [competitionContexts, setCompetitionContexts] = useState<string[]>([]);
  const [competitionLink, setCompetitionLink] = useState<string>('');
  const [competitionContextText, setCompetitionContextText] = useState<string>('');
  const [editContextText, setEditContextText] = useState<string>('');
  const [competitionCreativeOpen, setCompetitionCreativeOpen] = useState<boolean>(false);
  const [winnerIntroText, setWinnerIntroText ] = useState<LangObject[]>([]);
  const [winnerFinalText, setWinnerFinalText] = useState<LangObject[]>([]);
  const [enrollButtonText, setEnrollButtonText] = useState<LangObject[]>([]);

  const [criteriaList, setCriteriaList] = useState<Criteria[]>([]);

  const isExam = useMemo(() => {
    if (competition) {
      // @ts-ignore
      return competition?.lmsModuleProjectId;
    }
  }, [competition]);

  const [isAutomatic, setIsAutomatic] = useState<boolean>(false);
  const [isBriefCompetition, setIsBriefCompetition] = useState<boolean>(false)
  const [briefCompetitionFlow, setBriefCompetitionFlow] = useState<
  { label: string; value: string; }>(
    { 
      label: t(`competition_edit.designFabricForm.flows.label.first`), 
      value: FABRIC_FLOW.first
    }
  );
  const [isPreRegistration, setIsPreRegistration] = useState<boolean>(false);
  const [allowEmptyParticipantRequests, setAllowEmptyParticipantRequests] = useState(false);
  const [isPaidApplication, setIsPaidApplication] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Date | undefined>();
  const [endDate_Internal, setEndDate_Internal] = useState<Date | undefined>();
  const [endDate, setEndDate] = useState<Date | undefined>();
  const [requredTags, setRequredTags] = useState<Tag[]>([]);
  const [regularTags, setRegularTags] = useState<Tag[]>([]);
  const [exclusionTags, setExclusionTags] = useState<Tag[]>([]);

  const [showShortList, setShowShortList] = useState<boolean>(false);
  const [finalistsID, setFinalistsID] = useState<string[]>([]);
  const [winnerPositions, setWinnerPostitions] = useState<{ winnerId: string, position: number }[]>([]);
  const [voteCriterias, setVoteCriterias] = useState<Criteria[]>([]);
  const [tabsData, setTabsData] = useState<Tab[]>([]);
  const [maxCriteriaCount, setMaxCriteriaCount] = useState(MIN_CRITERIA_COUNT);
  const [maxParticipantsCount, setMaxParticipantsCount] = useState('');
  const [competitionDocuments, setCompetitionDocuments] = useState<{ label: string; value: number; }[]>([]);
  const [competitionDocumentOptions, setCompetitionDocumentOptions] = useState<{ label: string; value: number; }[]>([]);

  const onUpdate = useCallback(() => setTime(Date.now()), []);

  const [ onToggleBilingual ] = useToggleBilingual(competition, onUpdate);
  const [userColor, setUserColor] = useState<string>('#464645');
  const [longReadLength, setLongReadLength] = useState(0);
  const [statusText, setStatusText] = useState('');
  const [activePicker, setActivePicker] = useState('start');
  const [mobTextBlockLength, setMobTextBlockLength] = useState(0);
  const [mobileEditorOpen, setMobileEditorOpen] = useState(false);
  const [mobileEditorAction, setMobileEditorAction] = useState<string>(LongreadMobileActions.empty);
  const toggleMobileEditor = useCallback((val: boolean) => {
    setMobileEditorOpen(val);
  }, []);

  const handlePickerOpen = (pickerName: 'start' | 'tech' | 'end') => {
    setActivePicker(pickerName);
  };

  const handlePickerClose = () => {
    setActivePicker('start');
  };

  const getZIndex = (pickerName: 'start' | 'tech' | 'end') => {
    return activePicker === pickerName ? 91 : 90 - ['start', 'tech', 'end'].indexOf(pickerName);
  };

  const vtype = useSelector((state: any) => state.vt.vtype);

  //Новый вид отображания конкурсов
  const isNewType = true;

  const isBilingual = !!competition?.isBilingual;
  bilingualRef.current = isBilingual;

  const isModer = useMemo(() => {
    if (profile) {
      const hasPolicyCompetitionModer = profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

      //Предыдущая система ролевого доступа
      const isCompetitionModer = profile.rolesList && bArray.isArray(profile.rolesList) && profile.rolesList.some(x => x === "competitionmoder");

      return bProfile.isModer(profile) || hasPolicyCompetitionModer || isCompetitionModer;
    }
  }, [profile])

  // @ts-ignore
  const isRating = competition?.isRating;

  const hasAccessToContentAdmin = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_ui_content_admin)).containsIn(profile.rolesList);

  const isBriefModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList);

  const is744BP = useBreakpoint(LayoutConst.screen.s - 1);
  const is980BP = useBreakpoint(LayoutConst.screen.m);
  const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

  const DEFAULT_CRITERIA = { label: t('competition_edit.default_criteria'), value: ''}
  const DEFAULT_MAX_CRITERIA = useMemo(() => ({ label: maxCriteriaCount?.toString(), value: maxCriteriaCount.toString()}), [maxCriteriaCount])

  competitionIdRef.current = id;
  langRef.current = i18n.language;

  const competitionTitleImages = useMemo(() => {
    if (competition) {
      return {
        titleImages: competition?.titleImages,
        titleImages_en: competition?.titleImages_en,
        isBilingual: competition?.isBilingual
      } as any;
    }
    return {} as Project<'Global'>;
  }, [competition]);

  const competitionLongreads = useMemo(() => {
    if (competition) {
      return {
        longreadId: competition.longreadId,
        longreadId_en: competition.longreadId_en,
        longread: competition.longread,
        isBilingual: competition.isBilingual
      } as any;
    }
    return {} as Project<'Global'>;
  }, [competition]);

  useEffect(() => {
    if (vtype === 'fluid' && !WIDE_SCREEN_COLORS.includes(userColor)) {
      setUserColor('#464645');
    }
  }, [vtype])

  useEffect(() => {
    if (!profile) return;

    if (id) {
      CompetitionAPI.Get({ idCompetition: id })
          .then((value) => value.json() as Promise<Competition<'Global'>>)
          .then((value) => {
            if (value.competitionId) {
              setCompetition(value);
              setIsError(false);

              if (value.administratorID?.includes(profile.accountId)
                  || value.moderatorID?.includes(profile.accountId)
                  || (isBriefModer && value?.isBriefCompetition)
                  || isModer) {
                setIsForbidden(false);
                return;
              }

              setIsForbidden(true);

            } else {
              setCompetition(undefined);
              setIsError(true);
            }
          })
          .catch((reason) => {
            console.error(reason);
            setCompetition(undefined);
            setIsError(true);
          });
      return;
    }

    if (isModer || hasAccessToContentAdmin || isBriefModer) {
      setIsCreating(true);
      CompetitionAPI.AddDefaultCompetition()
      .then((res) => res.json())
      .then((res) => {
        setTimeout(() => {
          setIsCreating(false);
          history.replace(CreateLinkTo.competitionEdit(res.competitionId));
        }, 800);
      });
      
      return;
    }

    setIsForbidden(true);
  }, [id, profile, history, isModer, hasAccessToContentAdmin, isBriefModer, time]);

  const handleToggleBilingualClick = useCallback(() => onToggleBilingual && onToggleBilingual(), [onToggleBilingual])

  const handleToggleBriefCompetitionClick = useCallback((val: boolean ) => {
    if (isModer) {
      setIsBriefCompetition(val);
      setIsPreRegistration(val);
      setCompetitionCreativeOpen(false);

      setCompetitionContexts(
        !!val ? [...competitionContexts, COMPETITIONS_CONTEXTS.briefs] : 
        competitionContexts?.filter((context ) => context !== COMPETITIONS_CONTEXTS.briefs)
      )
    }

    return;
  } , [isModer, competitionContexts])

  const updateCriteria = useCallback(() => {
    const criterias: Criteria[] = voteCriterias
      ?.map((c) => ({ ...c, maxValue: maxCriteriaCount}))
      // @ts-ignore
      ?.map((c) => slicedKey('currentLang', c, 'delete'))

    const urlUpdate = `/api/competition/UpdateVoteCriteria`;
    Promise.all(criterias?.map((c) => (
      competition?.nominations?.[0]?.nominationID
      ? API.request()
        .endpoint(Endpoints.competitions)
        .url(urlUpdate)
        .addQuery('nominationId', competition.nominations[0].nominationID)
        .body(c)
        .post()
        .send()
      : API.request()
        .endpoint(Endpoints.competitions)
        .url(urlUpdate)
        .body(c)
        .post()
        .send()
    )))
  }, [competition?.nominations, maxCriteriaCount, voteCriterias]);

  useEffect(() => {
    updateCriteria();
  }, [maxCriteriaCount])

  useEffect(() => {
    if (competition) {
      // @ts-ignore
      setCompetitionName(competition.name.length ? competition.name : defaultCompetitionName);
      setCompetitionJuryText(competition.competitionInfo.juryText ?? []);
      setCompetitionVisibility(!!competition.visibility);
      // @ts-ignore
      setCompetitionIgnoreProjectShowcase(!!competition.ignoreProjectShowcase);

      setVoteCriterias([...competition?.nominations?.[0]?.voteCriterias]?.map((crt) => computeDataWithLang(crt) as Criteria));
      // @ts-ignore
      setTabsData(competition.infoTabs.length ? competition.infoTabs : DEFAULTTABS)

      const currentStatus = STATUSES_List.find(x => x.value === competition.status);
      setCompetitionStatus(currentStatus === undefined ? undefined : {...currentStatus, label: t('competition.statuses.'+currentStatus?.label)});
      setCompetitionContexts(competition.contexts || []);
      // @ts-ignore
      setCompetitionLink(competition.link);

      // @ts-ignore
      setWinnerIntroText(competition?.winnerText_Intro?.length ? competition?.winnerText_Intro : createDefaultLangObject('', true));
      // @ts-ignore
      setWinnerFinalText(competition?.winnerText_Final?.length ? competition?.winnerText_Final : createDefaultLangObject('', true));

      setEnrollButtonText(competition?.enrollButtonText?.length ? competition?.enrollButtonText : createDefaultLangObject('', true));

      setIsAutomatic(competition.isAutomatic);

      // @ts-ignore
      setIsBriefCompetition(competition.isBriefCompetition)

      // @ts-ignore
      setEditContextText(competition?.ratingSettings?.context)

      // @ts-ignore
      if (!!competition?.briefCompetitionFlow && competition?.isBriefCompetition) {
        // @ts-ignore
        const f =  Object.entries(FABRIC_FLOW)?.find(([k,v]) => v === competition?.briefCompetitionFlow);
        //@ts-ignore
        const [k,v] = f;

        setBriefCompetitionFlow({ label: t(`competition_edit.designFabricForm.flows.label.${k}`), value: v })
        
      }

      // @ts-ignore
      setIsPreRegistration(competition.isPreRegistration)

      // @ts-ignore
      setAllowEmptyParticipantRequests(competition.allowEmptyParticipantRequests)

      // @ts-ignore
      setIsPaidApplication(!!competition.isPaidApplication)

      setMaxCriteriaCount(
        competition?.nominations?.[0]?.customVoteMaxValue ?? competition?.nominations?.[0]?.voteCriterias?.[0]?.maxValue);

      if (competition.startDate) {
        let date = fixTimezoneOffsetToShow(new Date( Date.parse(competition.startDate) ));
        setStartDate(date);
      }

      if (competition.endDate_Internal) {
        let date = fixTimezoneOffsetToShow(new Date( Date.parse(competition.endDate_Internal) ));
        setEndDate_Internal(date);
      }

      if (competition.endDate) {        
        let date = isExam ? fixTimezoneLMSExamShow(new Date( Date.parse(competition.endDate) )) : fixTimezoneOffsetToShow(new Date( Date.parse(competition.endDate) ));
        setEndDate(date);
      }

      const ownRequredTags = [...competition.requredTags].map((tag) => {
        const translatedTag = API.toLang<Tag>(tag, i18n.language);
        return {
          ...translatedTag,
        }
      });

      setRequredTags(ownRequredTags);

      const ownRegularTags = [...competition.regularTags].map((tag) => {
        const translatedTag = API.toLang<Tag>(tag, i18n.language);
        return {
          ...translatedTag,
        }
      });

      setRegularTags(ownRegularTags);

      const ownExclusionTags = [...competition.exclusionTags].map((tag) => {
        const translatedTag = API.toLang(tag, i18n.language);
        return {
          //@ts-ignore
          ...translatedTag,
        }
      });

      setExclusionTags(ownExclusionTags);

      if (!!competition.maxParticipantsCount) {
        if (competition.maxParticipantsCount > DEFAULT_PARTICIPANTS_COUNT) {
          setMaxParticipantsCount(competition.maxParticipantsCount.toString());
        }
        else {
          setMaxParticipantsCount('');
        }
      }
      else {
        setMaxParticipantsCount('');
      }

      if (competition.competitionColorTheme?.backgroundColor) {
        setUserColor(competition.competitionColorTheme.backgroundColor === '#FEFEFE' ? '#464645' : competition.competitionColorTheme.backgroundColor);
      }

      if (competition.nominations[0]) {
        setCompetitionCreativeOpen(competition.nominations[0].needToFillForm);
        // @ts-ignore
        setShowShortList(competition.nominations[0].showShortList);
        setFinalistsID(competition.nominations[0].finalistsID);

        //@ts-ignore
        setWinnerPostitions(competition.nominations[0].winnerPositions);
      }

      CompetitionAPI.GetVoteCriteriaList()
        .then((r) => r.json())
        .then((r) => setCriteriaList(r))
    }
  }, [competition, isBriefModer, t, i18n]);

  useEffect(() => {
    if (competition) {
      const administrators = (competition.administrators || []) as Designer<'Global'>[];
      const moderators = (competition.moderators || []) as Designer<'Global'>[];
      const juries = (competition.juries || []) as Designer<'Global'>[];

      setCompetitionAdministrators(administrators.length !== 0 ? [
        {
          ...convertDesignerFromGlobalToLocal(administrators[0], i18n.language),
          disabled: true
        },
        ...administrators.slice(1).map(admin => convertDesignerFromGlobalToLocal(admin, i18n.language))
      ] : []);

      setCompetitionModerators(moderators.map((moder) => convertDesignerFromGlobalToLocal(moder, i18n.language)));
      setCompetitionJury(juries.map((jury) => convertDesignerFromGlobalToLocal(jury, i18n.language)));
    }
  }, [
    competition,
    i18n.language
  ]);

  useEffect(() => {
    if (competition) {
      DocumentAPI.GetDocumentsService({
        service: ["competitions"]
      })
      .then(data => data.json())
      .then(data => {
        if (data?.length) {
          const options = data?.map((item, index) => ({ label: item?.documentId, value: index }));
          setCompetitionDocumentOptions(options);
          if (competition?.nominations?.[0]) {
           setCompetitionDocuments(options?.filter(x => competition?.nominations?.[0]?.documentsIds.includes(x?.label)));
         }
        }
      });
    }
  }, [competition]);

  useEffect(() => {
    if (competition && competition.competitionId) {
      if (throttle.current) {
        clearTimeout(throttle.current);
        throttle.current = null;
      }

      setStatusText(t('saving'));

      throttle.current = setTimeout(() => {
        if (competition && competition.competitionId) {
          const copy: Competition<'Global'> = {
            ...competition
          };
          copy.administratorID = competitionAdministrators.map(x => x.accountId);
          copy.moderatorID = competitionModerators.map(x => x.accountId);
          copy.juryID = competitionJury.map(x => x.accountId);
          copy.competitionInfo.juryText = competitionJuryText;
          copy.visibility = competitionVisibility;
          //@ts-ignore
          copy.ignoreProjectShowcase = competitionIgnoreProjectShowcase;
          copy.status = competitionStatus?.value ?? 0;
          copy.contexts = competitionContexts;
           if (outerLinkIsValid) {
               copy.link = competitionLink;
             }
          //@ts-ignore
          copy.infoTabs = tabsData.length ? tabsData : DEFAULTTABS;
          copy.competitionColorTheme = {
            backgroundColor: userColor,
            accentColor: null,
            fontColor: null,
            bannerFontColor: null,
            stagesBackgroundColor: null,
            stagesFontColor: null,
            buttonBackgroundColor: null,
            buttonFontColor: null,
           };

          if (competitionName) {
            copy.name = competitionName;
            copy.title = competitionName;
          }

          if (copy.nominations[0]) {
            copy.nominations[0].needToFillForm = competitionCreativeOpen;
            copy.nominations[0].documentsIds = competitionDocuments.map(item => item.label);
            // @ts-ignore
            copy.nominations[0].showShortList = showShortList;
            copy.nominations[0].finalistsID = finalistsID;
            //@ts-ignore
            copy.nominations[0].winnerPositions = winnerPositions?.filter(x => !x?.isEmpty);
            //@ts-ignore
            const filterCriterias = voteCriterias?.filter((crt) => !crt?.isNew)
            //@ts-ignore
            copy.nominations[0].voteCriteriasID = filterCriterias?.map((crt) => (crt.voteCriteriaId)) 
            copy.nominations[0].customVoteMaxValue = maxCriteriaCount;
            copy.nominations[0].customVoteMinValue = 1;
          }

          copy.isAutomatic = isAutomatic;
          copy.isPreRegistration = isPreRegistration;
          //@ts-ignore
          copy.allowEmptyParticipantRequests = allowEmptyParticipantRequests;
          //@ts-ignore
          copy.isPaidApplication = isPaidApplication;
          copy.isNewType = isNewType;
          copy.startDate = fixTimezoneOffsetToSave(startDate)?.toJSON();
          copy.endDate_Internal = fixTimezoneOffsetToSave(endDate_Internal)?.toJSON();
          copy.endDate = isExam ? fixTimezoneLMSExam(endDate)?.toJSON() : fixTimezoneOffsetToSave(endDate)?.toJSON();
          copy.requredTagIds = [...requredTags].map((value) => value.tagId);
          copy.regularTagIds = [...regularTags].map((value) => value.tagId);
          copy.exclusionTagIds = [...exclusionTags].map((value) => value.tagId);
          copy.maxParticipantsCount = Number(maxParticipantsCount);
          //@ts-ignore
          copy.ratingSettings = isRating ? {...competition?.ratingSettings, context: editContextText} : null;
          copy.isBriefCompetition = isBriefCompetition;

          if (isBriefCompetition) {
            //@ts-ignore
            copy.briefCompetitionFlow = briefCompetitionFlow.value;
          }

          //@ts-ignore
          copy.winnerText_Intro = winnerIntroText;
          //@ts-ignore
          copy.winnerText_Final = winnerFinalText;
          copy.enrollButtonText = enrollButtonText;

          CompetitionAPI.Update(copy)
            .then(() => {
              setTimeout(() => setStatusText(t('saved')), 1000);
            })
            .catch(() => setIsUpdateError(true));
        }
      }, 1000);
    } else {
      setStatusText('Loading competition...');
    }
  }, [
    history,
    competition,
    profile,
    competitionName,
    maxParticipantsCount,
    competitionAdministrators,
    maxCriteriaCount,
    competitionModerators,
    competitionJury,
    competitionJuryText,
    voteCriterias,
    competitionVisibility,
    isBriefCompetition,
    briefCompetitionFlow,
    competitionIgnoreProjectShowcase,
    isPreRegistration,
    allowEmptyParticipantRequests,
    isPaidApplication,
    competitionStatus,
    competitionContexts,
    competitionCreativeOpen,
    winnerIntroText,
    winnerFinalText,
    isAutomatic,
    startDate,
    endDate_Internal,
    endDate,
    requredTags,
    regularTags,
    exclusionTags,
    showShortList,
    finalistsID,
    winnerPositions,
    competitionDocuments,
    userColor,
    isExam,
    competitionLink,
    enrollButtonText,
    tabsData,
    editContextText,
    id,
    t,
  ]);

  useEffect(() => {
    if (competition?.longread) {
      dispatch(setType(competition?.longread?.viewType || 'container'));
    }

  }, [competition, dispatch])

  const getRedirectIfBackClick = useCallback(() => {
    //@ts-ignore
    history.push(competition?.lmsModuleProjectId ? CreateLinkTo.projectEdit(competition?.lmsModuleProjectId) : CreateLinkTo.competitionsAdmin());
  }, [history, competition]);

  const uploaderCallback = useCallback((fileId: Voidable<string>) => {
    if (!fileId) {
      return null;
    }
    CompetitionAPI.UploadFile({
      fileId,
      profileId: competitionIdRef.current,
      service: 'geography',
      entityType: 'competitionimage',
      ...(bilingualRef.current === true ? {
        localization: langRef.current,
      } : {})
    })
    .then((res) => {
      sipRef.current.uploader.uploader.uppy.reset();
      return res;
    });
  }, [competitionIdRef, bilingualRef, langRef])

  const uploadValidator = useCallback(async (files: any) => {
    let failedChecks: {
      dimensions?: boolean;
      size?: boolean;
      ratio?: boolean;
      type?: boolean;
    } = {};

    if (!['image/jpeg'].includes(files?.[0]?.type)) {
      toasts.error(t('project_edit.image_error.wrong_format'));
      failedChecks.size = true;
    }

    const {
      size: failedSize,
    } = failedChecks;

    if (failedSize) {
      return false;
    }

    return true;
  }, [t]);

  const sip = useSimpleUploader(uploaderCallback, uploadValidator);
  const sip_en = useSimpleUploader(uploaderCallback, uploadValidator);
  sipRef.current = sip;
  sipRefEn.current = sip_en;

  const outerLinkIsValid = useMemo(
    () => (competitionLink?.length ? !!COMPETITION_LINK_REG.test(competitionLink) : true) , [competitionLink]);

  const errorsArray = useMemo(() => {
    const errors = [];
    if(requredTags.length === 0 && !isRating){
      errors.push(`${t('create.tips.fill')}`);
    }

    if (!outerLinkIsValid) {
      errors.push(`${t('create.tips.wrong_link_format')}`);
    }
    return errors;
  }, [outerLinkIsValid, requredTags, t])

  const primaryButtonText = useMemo(() => t('save'), [t]);
  const emptyVoteCriterias = voteCriterias?.some(item => Lang(item?.name, 'ru') === '')
  const primaryButtonClick = useCallback((): void => {
    if (!!mobileEditorOpen) {
      setMobileEditorAction(LongreadMobileActions.add);
      setMobTextBlockLength(0);
      setTimeout(() => {
        setMobileEditorAction(LongreadMobileActions.empty);
        toggleMobileEditor(false);
      }, 1000);
      return;
    }

    // @ts-ignore
    if (competition?.lmsModuleProjectId) {
      // @ts-ignore
      history.push(CreateLinkTo.projectEdit(competition?.lmsModuleProjectId))
      return
    }
    if (profile && (isModer || hasAccessToContentAdmin || isBriefModer)) {
        history.push(CreateLinkTo.competitionsAdmin());
    }
  }, [history, profile, isModer, hasAccessToContentAdmin, isBriefModer, competition, mobileEditorOpen, toggleMobileEditor]);

  const hasTitle = useMemo(
    () => !!competitionName?.length && competitionName?.every((i) => i?.name !== ''), [competitionName])


  const handleSetMobTextLengthChange = useCallback((val: number) => {
    setMobTextBlockLength(val);
  }, []);



  const canSaveLgText = useMemo(
    () => mobTextBlockLength > 0, 
    [mobTextBlockLength]
  );

   
  const PortalMenu = useMemo(() => {
    const outer = document.getElementById('navbar-portal');

    if (!outer) {
      return null;
    }
    
    const isReadyToNext = (hasTitle && !!requredTags.length && outerLinkIsValid && !emptyVoteCriterias && !!startDate && !!endDate_Internal && !!endDate ) || isRating || (!!mobileEditorOpen ? canSaveLgText : false);
    return createPortal(
              <NavbarCreate
          className={className}
          isReadyToNext={isReadyToNext}
          primaryButtonEnabled={isReadyToNext}
          primaryButtonText={primaryButtonText}
          stateText={statusText}
          onSecondaryClick={getRedirectIfBackClick}
          onPrimaryClick={primaryButtonClick}
          errors={errorsArray}
          previewButtonVisible={false}
          mobileEditorOpen={mobileEditorOpen}
          toggleMobileEditor={toggleMobileEditor}
          // @ts-ignore
          isLMSModule={!!competition?.lmsModuleProjectId}
        />,
      outer,
    );
  }, [
    longReadLength,
    hasTitle,
    className,
    primaryButtonText,
    statusText,
    primaryButtonClick,
    getRedirectIfBackClick,
    errorsArray,
    mobTextBlockLength,
    mobileEditorOpen,
    canSaveLgText,
    mobileEditorAction,
    requredTags,
    outerLinkIsValid,
    emptyVoteCriterias,
    startDate,
    endDate_Internal,
    endDate,
    isRating
  ]);

  const brighter = useMemo(() => bColor.getBrighter(userColor, 10), [userColor]);
  const darker = useMemo(() => bColor.getBrighter(userColor, -20), [userColor]);
  const custom = {
    customBackgroundColor: Colors.galBlack5,
    customBorderColor: 'transparent',
    customBorderColorHover: 'transparent',
    customTextColor: Colors.galBlack100,
    customPlaceholderColor: Colors.galBlack47,
  };


  const CriteriaOptions = useMemo(() => {
    if (criteriaList?.length) {
      //@ts-ignore
        return criteriaList?.reduce((acc,val) => {
          return [...acc, { label: Lang(val?.name, i18n.language), value: val?.voteCriteriaId }]
      }, [])
    }
  }, [criteriaList, i18n.language]);

  const criteriaMaxValues = useMemo(() => {
    const list = [MIN_CRITERIA_COUNT, MAX_CRITERIA_COUNT];
      //@ts-ignore
        return list?.reduce((acc,val) => {
          return [...acc, { label: val, value: val}]
      }, [])

  }, [i18n.language]);

  const competitionFinish = useMemo(
    () => (competitionStatus?.value && [STATUSES.Completed, STATUSES.Archived]?.includes(competitionStatus?.value)), [competitionStatus])

  const onCompetitionNameChange = useCallback((value: string) => {
    setCompetitionName(setCompetitionStringValueByLang(competition?.isBilingual || false, competitionName, i18n.language, value))
  }, [competitionName, i18n.language, competition]);

  const onCompetitionAdministratorsChange = useCallback(({ authors, action }: ProjectAuthorsChangeCbT) => {
    if (action === 'remove-value') {
      if (authors.length === 0) {
        toasts.error('администраторов не может быть 0');
        return;
      }
    }
    setCompetitionAdministrators(authors);
  }, [toasts]);

  const onTeamTabSortEnd = useCallback((oldIndex: number, newIndex: number) => {
    const tabs = arrayMoveImmutable(voteCriterias, oldIndex, newIndex)
    setVoteCriterias(tabs);
  }, [setVoteCriterias, voteCriterias]);

  const allowedCriteriaValue = (crt: Criteria) => {
    // @ts-ignore
    const name = Lang(crt?.name, crt?.currentLang || i18n.language);
    // @ts-ignore
    if (crt?.isNew && !!name?.length) {

      const namesRu = criteriaList?.map((crt) => {
        return crt?.name[0]?.name?.toLowerCase()
      });
    
      const namesEng = criteriaList?.map((crt) => {
        return crt?.name[1]?.name?.toLowerCase()
      });
    
      return [...namesRu, ...namesEng]?.includes(name)
    }

    return false;
  } 

  const onCriterialNameChange = (text: string,  id: string, lang: string) => {
      const criterias = voteCriterias?.map((crt) => {
        if (crt?.voteCriteriaId === id) {
          return {
            ...crt, name: setTextByLang(crt?.name, lang, text)
          }
        }
        return crt
      });
      setVoteCriterias(criterias);  
  };
    
  const onTabNameChange = (text: string, id: string, lang: string) => {
    const updatedTabs = tabsData.map((tab) => {
      if (tab.position === Number(id)) { 
        return {
          ...tab,
          name: setTextByLang(tab.name, lang, text)
        };
      }
      return tab;
    });
    setTabsData(updatedTabs); 
  };

  const onTabCheckboxChange = (value: boolean, id: number) => {
    const updatedTabs = tabsData.map((tab) => {
      if (tab.position === Number(id)) { 
        return {
          ...tab,
          enable: value
        };
      }
      return tab;
    });
    setTabsData(updatedTabs); 
  };

  const onCriteriaDeleteClick = (id: string) => {
    const confirmation = window.confirm('Вы действительно хотите удалить критерий?');
    if (confirmation) {
      setVoteCriterias(voteCriterias?.filter((crt) => crt?.voteCriteriaId !== id));
    }
  }

  const onSubmitNewCriteria = (crt: Criteria) => {
    const computeCriteria = {
      name: crt?.name as LangObject[],
      voteCriteriaId: crt?.voteCriteriaId,
      maxValue: maxCriteriaCount,
      minValue: 1
    }
    CompetitionAPI.AddVoteCriteria(computeCriteria)
    .then((r) => r.json())
    .then((r) => {
      if (!!r?.length) {
        setVoteCriterias([...voteCriterias?.slice(0, voteCriterias?.length - 1), { ...computeCriteria, voteCriteriaId: r }])
      }

      CompetitionAPI.GetVoteCriteriaList()
    });
  }

  const onCreateNewCriteria = () => {
    const defaultCrt = { voteCriteriaId: '', name: createDefaultLangObject(''), maxValue: maxCriteriaCount, minValue: 1, isNew: true}
    setVoteCriterias([...voteCriterias, defaultCrt]);
  }

  const onCompetitionModeratorsChange = ({ authors }: ProjectAuthorsChangeCbT) => {
    setCompetitionModerators(authors);
  };

  const onCompetitionJuryChange = ({ authors }: ProjectAuthorsChangeCbT) => {
    setCompetitionJury(authors);
  };

  const onCompetitionJuryTextChange = useCallback((value: string) => {
    setCompetitionJuryText(setCompetitionStringValueByLang(false, competitionJuryText, i18n.language, value))
  }, [competitionJuryText, i18n.language]);

  const onSortWinners = useCallback((oldIndex: number, newIndex: number): void => {
    const arr = arrayMoveImmutable(winnerPositions, oldIndex, newIndex)
    setWinnerPostitions(arr);
  }, [winnerPositions]);

  const onDeleteContext = (i: string) => {
    const confirm = window.confirm(t('confirmation.context_delete'))

    if (confirm) {

      if (isBriefModer && i === COMPETITIONS_CONTEXTS.briefs) {
        toasts.error('Вы не можете удалить бриф контекст. Обратитесь к модератору');
        return;
      }
      setCompetitionContexts(competitionContexts?.filter((k) => k !== i));

      if (i === COMPETITIONS_CONTEXTS.briefs) {
        setIsBriefCompetition(false)
      }
    }
  }

  const minStartDate = useMemo(() => {
    const date = new Date(Date.now())

    if (competitionFinish) {
      return undefined;
    }
    
    if (startDate && startDate < date) {
      return startDate;
    }

    return date;
  }, [startDate, competitionFinish]);

  const handleDateChange = (setDateFunction: any) => (value: Date) => {
    setDateFunction(value);
  };
  
  const handleBlur = (setDateFunction: any, currentDate: Date | undefined) => () => {
    const minDate = new Date();
      
    if (currentDate && currentDate < minDate) {
      handleDateChange(setDateFunction)(minDate);
    }
    if (currentDate === undefined || currentDate === null) {
      setDateFunction(fixTimezoneOffsetToShow(new Date(Date.now())));
    }
  };
  const handleCompetitionBlur = (setDateFunction: any, currentDate: Date | undefined) => () => {
    const minDate = new Date(2022, 0, 1); 
    
    if (currentDate && currentDate < minDate) {
      handleDateChange(setDateFunction)(minDate);
    }
    if (currentDate === undefined || currentDate === null) {
      setDateFunction(fixTimezoneOffsetToShow(new Date(Date.now())));
    }
  };
  const handleEndDateBlur = (setDateFunction: any, currentDate: Date | undefined) => () => {
    
    if (startDate && currentDate && currentDate < startDate) {
      handleDateChange(setDateFunction)(startDate);
    }
    if (currentDate === undefined || currentDate === null) {
      setDateFunction(fixTimezoneOffsetToShow(new Date(Date.now())));
    }
  };

  const rebuildWinnerPositions = useCallback((items: {project?: Project, position?: number, isEmpty?: boolean, projectId?: string}[], isDelete?: boolean) => {
    const temp = items.map((x, idx )=> {
      const current = winnerPositions.find(f => f.winnerId === x?.project?.projectId);

      return { winnerId: isDelete ? x?.projectId || '' : x?.project?.projectId || "", position: !current ? idx + 1 : current.position };
    });

    setWinnerPostitions(temp);
  }, [winnerPositions]);

  const onSetWinnerPostitions = useCallback((projectIds: string[], position?: number) => {
    const temp = projectIds?.reverse().map((x, idx) => {
      const current = winnerPositions.find(f => f.winnerId === x);

      return { winnerId: x, position: !current ? idx + 1 : current.position };
    });

    setWinnerPostitions(temp);
  }, [winnerPositions]);

  const onSetWinnerPosition = useCallback((index: number, position: number) => {
    const temp = [...winnerPositions];
    temp[index].position = position;
    setWinnerPostitions(temp);
  }, [winnerPositions]);

  const onLocalLangChange = (arr: any[], lang: string, callback: (test: any[]) => void) => callback(arr?.map((i: any) => ({ ...i, currentLang: lang === 'ru' ? 'en' : 'ru' })));

  const onLocalLangChanges = (
    arr: any[], 
    lang: string, 
    tabId: string, 
    callback: (updatedTabs: any[]) => void
  ) => {
    const updatedTabs = arr.map((tab: any) =>
        tab.tabId === tabId
            ? { ...tab, currentLang: lang === 'ru' ? 'en' : 'ru' }
            : tab 
    );
    
    callback(updatedTabs);
  };
  const criteriasBlock = useMemo(() => {
    // @ts-ignore
    const currentLang = voteCriterias?.find((crt) => crt?.currentLang)?.currentLang || 'ru';
    // @ts-ignore
    const hasNewCriteria = voteCriterias?.some((crt) => crt?.isNew);

    return (
      <CriteriaWrapper gyMobile={8} offsetBottom={isMac13 ? 40 : 56} offsetBottomMobile={40} direction="column" directionMobile="column">
        <LangTitleBox 
          title={t('competition_edit.labels.criterias')} 
          mainTitle 
          onLangChange={() => onLocalLangChange(voteCriterias, currentLang, (val) => setVoteCriterias(val))} 
          lang={currentLang} 
          isCompetitionEdit
        />
        {!!criteriaList?.length && (
          <FlexBox offsetTop={24} offsetTopMobile={1}>
            <CommonInput 
              type={INPUT_TYPES.dropdown}
              value={DEFAULT_CRITERIA}
              //@ts-ignore
              options={CriteriaOptions}
              onChange={(item: any, currentLang?: string) => {
                const crt = criteriaList?.find((crt) => crt?.voteCriteriaId === item?.value);
                const has = voteCriterias?.find((crt) => crt?.voteCriteriaId === item?.value) 
                if (crt && !has) {
                  setVoteCriterias([...voteCriterias, crt])
                }
              }}
            />
          </FlexBox>
        )}
        <FlexBox offsetTop={24} offsetTopMobile={24} direction="row" directionMobile="column" width={'100%'} justify="space-between" align="center">
          <CriteriaMaxValueLabel width={'calc(100% - 292px)'} widthMobile={'100%'} offsetBottomMobile={8}>
            {t('competition_edit.default_max_criteria')}
          </CriteriaMaxValueLabel>
          <FlexBox width={'292px'} widthMobile={'100%'}>
            <CommonInput 
              type={INPUT_TYPES.dropdown}
              options={criteriaMaxValues as any}
              value={DEFAULT_MAX_CRITERIA}
              onChange={(item: any) => {
                setMaxCriteriaCount(item?.value)
              }}
            />
          </FlexBox>
        </FlexBox>
        {!!voteCriterias?.length && (
          <SortableWrapper offsetTop={24} offsetTopMobile={16}>
            <SortableList as={'tbody'} onSortEnd={onTeamTabSortEnd}>
              {voteCriterias.map((crt, index) => {
                const name = Lang(crt.name, currentLang);
                // @ts-ignore
                const isNewCriteria = crt?.isNew;

                if (isNewCriteria) {
                  return (
                    <div>
                          <tr>
                            <td style={{ width: '100%', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                  <SortableKnob>
                                    <div style={{  
                                      cursor: 'not-allowed' , 
                                      backgroundColor: 'transparent', 
                                      ...(isNewCriteria && { pointerEvents: 'none' }),
                                      }}
                                    >
                                      <DottedIcon />
                                    </div>
                                  </SortableKnob>
                                    <CommonInput 
                                      type={INPUT_TYPES.text}
                                      maxLength={100}
                                      disable={!isNewCriteria}
                                      value={!!name ? name : ''}
                                      onChange={(ev: any) => onCriterialNameChange(ev?.target?.value, crt?.voteCriteriaId, currentLang)}
                                    />
                                    {!!allowedCriteriaValue(crt) && (
                                      <span className={'not-allowed-text'}>{t('competition_edit.error_criteria_text')}</span>
                                    )}
                                    {emptyVoteCriterias && (
                                      <span className={'not-allowed-text'}>{t('competition_edit.fill_criteria_text')}</span>
                                    )}
                                    {isNewCriteria && (
                                      <Counter>{`${name?.length}/100`}</Counter>
                                    )}
                                </TableSortWrapper>
                            </td>
                            <td style={{ paddingLeft: 24, width: !isNewCriteria ? 131 : 'auto', padding: isMobile ? '8px 0px' : '' }}>
                                <FlexBox direction={'row'} directionMobile="row" gx={isNewCriteria ? 10 : 0} gxMobile={isNewCriteria ? 10 : 0} justify={isNewCriteria ? 'center' : 'end'} width={isNewCriteria ? '100%' : '131px'} widthMobile={'100%'} justifyMobile={isMobile ? 'end' : 'start'}>
                                  {isNewCriteria ? (
                                    <FlexBox direction="row" justify="center" gx={20} gxMobile={20}>
                                      <ApprovedIcon disabled={emptyVoteCriterias} className={'icon'} fill={'#909090'}  display={true} width={25} height={25} onClick={() => onSubmitNewCriteria(crt)}/>
                                      <BasketIcon className={'icon'} fill={'#909090'} onClick={() => onCriteriaDeleteClick(crt?.voteCriteriaId)}/>
                                    </FlexBox>
                                  ) : (
                                    <DefaultButton wh={131} whMob={107} onClick={() => onCriteriaDeleteClick(crt?.voteCriteriaId)}>Удалить</DefaultButton>
                                  )}
                                
                                </FlexBox>
                            </td>
                        </tr>
                    </div>
                  )
                }
                return (
                    <SortableItem key={"team-tab-sortable_" + index}>
                        <tr>
                            <td style={{ width: '100%', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                  <SortableKnob>
                                    <div style={{
                                      cursor: 'grab',   
                                      backgroundColor: 'transparent', 
                                      }}
                                    >
                                      <DottedIcon />
                                    </div>
                                  </SortableKnob>
                                    <Input.Text 
                                      maxLength={100}
                                      value={!!name ? name : ''}
                                      disabled={!isNewCriteria}
                                      //@ts-ignore
                                      onChange={(ev) => onCriterialNameChange(ev?.target?.value, crt?.voteCriteriaId, currentLang)}
                                    />
                                    {!!allowedCriteriaValue(crt) && (
                                      <span className={'not-allowed-text'}>{t('competition_edit.error_criteria_text')}</span>
                                    )}
                                    {isNewCriteria && (
                                      <Counter>{`${name?.length}/100`}</Counter>
                                    )}
                                </TableSortWrapper>
                            </td>
                            <td style={{ paddingLeft: 24, width: !isNewCriteria ? 131 : 'auto', padding: isMobile ? '8px 0px' : '' }}>
                                <FlexBox direction={'row'} directionMobile="row" gx={isNewCriteria ? 10 : 0} gxMobile={isNewCriteria ? 10 : 0} justify={isNewCriteria ? 'center' : 'end'} width={isNewCriteria ? '100%' : '131px'} widthMobile={'100%'} justifyMobile={isMobile ? 'end' : 'start'}>
                                    <DefaultButton wh={131} whMob={107} onClick={() => onCriteriaDeleteClick(crt?.voteCriteriaId)}>Удалить</DefaultButton>
                                </FlexBox>
                            </td>
                        </tr>
                    </SortableItem>
                );
              })}
            </SortableList>
          </SortableWrapper>
        )}
        {!hasNewCriteria && (
          <FlexBox offsetTop={10}>
            <DefaultButton wh={195} whMob={195} onClick={() => {
                onCreateNewCriteria();
            }}>
              <PlusSvg />
                Создать
            </DefaultButton>
        </FlexBox>
        )}

    </CriteriaWrapper>
    )
  }, [voteCriterias, CriteriaOptions, isMac13, criteriaMaxValues, DEFAULT_MAX_CRITERIA])

  const hasTag = useCallback((currentTags: Tag[],tags: Tag[]) => {
    return !!currentTags
    ?.map((tag) => tag?.tagId)
    ?.find((i) => tags
      ?.some(({ tagId }) => tagId === i)
    )
  }, [])

  const winnerTextBlock = useMemo(() => {

    return (
      <CompetitionEditPageGridRow>
         <CommonInput 
          minHeight={120}
          orientation="wide"
          type={INPUT_TYPES.textarea}
          maxLength={800}
          label={t('competition_edit.winner_intro_text')}
          value={winnerIntroText}
          useLangSwitcher
          onChange={(value: any, currentLang?: string) => setWinnerIntroText(setTextByLang(winnerIntroText, currentLang ?? 'ru', value.target.value))}
        />
      </CompetitionEditPageGridRow>
    )
  }, [winnerIntroText]);

  const winnerFinalTextBlock = useMemo(() => {
    return (
      <CompetitionEditPageGridRow>
        <CommonInput 
          minHeight={120}
          orientation="wide"
          type={INPUT_TYPES.textarea}
          maxLength={800}
          label={t('competition_edit.winner_final_text')}
          value={winnerFinalText}
          useLangSwitcher
          onChange={(value: any, currentLang?: string) => setWinnerFinalText(setTextByLang(winnerFinalText, currentLang ?? 'ru', value.target.value))}
      />
      </CompetitionEditPageGridRow>
    )
  }, [winnerFinalText])

  const requiredTagsInput = useMemo(() => <TagsWrapper isExam={isExam}>
    <CompetitionEditPageGridLabel {...custom} nowrap>
      {t('competition_edit.required_tags')}
     {!isRating && <LabelRedStar>*</LabelRedStar>} 
    </CompetitionEditPageGridLabel>
    <CompetitionContentAddContainer>
      {/* @ts-ignore */}
      {!competition?.lmsModuleProjectId && <AddTagsWrapper
          isEmpty={!requredTags?.length}
          onClick={() => modal.show('tags', {
            value: [...requredTags],
            global: true,
            isEdit: true,
            // global: true,
            onChange: (tagsRaw: Tag[]) => {
              if (hasTag(exclusionTags, tagsRaw)) {
                toasts.error(t('project_edit.unic_tags'))
                return;
              }

              setRequredTags(tagsRaw);
            }
          })}>
        <PlusIconThin/>
        <ButtonText>{t('project_edit.tags_button_empty_text')}</ButtonText>
      </AddTagsWrapper>}
      {!!requredTags?.length && (
          <BTagsGridNew scrollMode="all" style={{ marginBottom: "0px" }}>
            {[...requredTags].map((value: any) => (
                <BTag
                    tag={value}
                    removable
                    educational={value.isEducationTag}
                    isProjectsTag
                    onClick={() => {
                      // @ts-ignore
                      if (!competition?.lmsModuleProjectId) setRequredTags((v) => v.filter((tag) => tag.tagId !== value.tagId));
                    }}
                    key={value.tagId}
                >
                  {bTag.title(value)}
                </BTag>
            ))}
          </BTagsGridNew>
      )}
    </CompetitionContentAddContainer>
    {/* @ts-ignore */}
  </TagsWrapper>, [t, setRequredTags, requredTags, regularTags, isExam, competition?.lmsModuleProjectId, hasTag, exclusionTags])

  // @ts-ignore
  const submitButton = useMemo(() => <ButtonFilled isLMS={competition?.lmsModuleProjectId} disabled={!hasTitle} onClick={primaryButtonClick}>{primaryButtonText}</ButtonFilled>, [t, primaryButtonClick, primaryButtonText, hasTitle])

  const regularTagsInput = useMemo(() => <TagsWrapper isExam={isExam}>
    <CompetitionEditPageGridLabel {...custom}>
      {t('competition_edit.default_tags')}
    </CompetitionEditPageGridLabel>
    <CompetitionContentAddContainer>
      {/* @ts-ignore */}
      {!competition?.lmsModuleProjectId && <AddTagsWrapper
          isEmpty={!regularTags?.length}
          onClick={() => modal.show('tags', {
            value: regularTags,
            isEdit: true,
            onChange: (tagsRaw: Tag[]) => {
              setRegularTags(tagsRaw);
            }
          })}>
        <PlusIconThin/>
        <ButtonText>{t('project_edit.tags_button_empty_text')}</ButtonText>
      </AddTagsWrapper>}
      {!!regularTags?.length && (
          <BTagsGridNew style={{ marginBottom: "0px" }}>
            {regularTags.map((value: any) => (
                <BTag
                    tag={value}
                    removable
                    educational={value.isEducationTag}
                    isProjectsTag
                    onClick={() => {
                      // @ts-ignore
                      if (!competition?.lmsModuleProjectId) setRegularTags((v) => v.filter((tag) => tag.tagId !== value.tagId));
                    }}
                    key={value.tagId}
                >
                  {bTag.title(value)}
                </BTag>
            ))}
          </BTagsGridNew>
      )}
    </CompetitionContentAddContainer>
    {/* @ts-ignore */}
  </TagsWrapper>, [t, setRegularTags, regularTags, isExam, competition?.lmsModuleProjectId])

  const excludingTagsInput = useMemo(() => <TagsWrapper isExam={isExam}>
    <CompetitionEditPageGridLabel {...custom}>
      {t('competition_edit.excluding_tags')}
    </CompetitionEditPageGridLabel>
    <CompetitionContentAddContainer>
      <AddTagsWrapper
          isEmpty={!exclusionTags?.length}
          onClick={() => modal.show('tags', {
            value: exclusionTags,
            isEdit: true,
            onChange: (tagsRaw: Tag[]) => {
              if (hasTag(requredTags, tagsRaw)) {
                toasts.error(t('project_edit.unic_tags'))
                return;
              }
              setExclusionTags(tagsRaw);
            }
          })}>
        <PlusIconThin/>
        <ButtonText>{t('project_edit.tags_button_empty_text')}</ButtonText>
      </AddTagsWrapper>
      {!!exclusionTags?.length && (
          <BTagsGridNew style={{ marginBottom: "0px" }}>
            {exclusionTags.map((value: any) => (
                <BTag
                    tag={value}
                    removable
                    educational={false}
                    isProjectsTag
                    onClick={() => {
                      setExclusionTags((v) => v.filter((tag) => tag.tagId !== value.tagId));
                    }}
                    key={value.tagId}
                >
                  {bTag.title(value)}
                </BTag>
            ))}
          </BTagsGridNew>
      )}
    </CompetitionContentAddContainer>
  </TagsWrapper>, [t, setExclusionTags, exclusionTags, isExam, hasTag, requredTags])


  const competitionExamNameInput = useMemo(() => (
    <CommonInput 
      type={INPUT_TYPES.text}
      label={t('teams.adminPage.fields.name')}
      value={Lang(competitionName, i18n.language)}
      onChange={(value: any) => onCompetitionNameChange(value.target.value)}
      disable
    />
  ), [t, competitionName, i18n, onCompetitionNameChange])

  const filteredStatuses = STATUSES_List.filter(item =>
  ['Open', 'Voting', 'Completed'].includes(item.label)
  );
  const getLabel = (label: string | undefined) => {
    if (label === 'Voting') {
      return t('competition.statuses.VotingLMS');
    }
    return t('competition.statuses.' + label);
  };
  // @ts-ignore
  const competitionStatusInput = useMemo(() => {
    const value = {label: getLabel(STATUSES?.[competitionStatus?.value || 1]), value: competitionStatus?.value} as any;
    const opt = filteredStatuses.map(item => ({...item, label: getLabel(item.label)})) as any
    return (
      <CommonInput 
      type={INPUT_TYPES.dropdown}
      label={t('competition_edit.status')}
      options={opt}
      value={value}
      onChange={(item: any) => setCompetitionStatus(item)}
    />
    )
  }, [t, isMobile, competitionStatus, setCompetitionStatus])

  const startDateInput = useMemo(() => <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('start') }}>
    {/* @ts-ignore */}
    <CompetitionEditPageGridLabel isLMS={competition?.lmsModuleProjectId}>
      {/* @ts-ignore */}
      {competition?.lmsModuleProjectId ? t('competition_edit.exam_start_date') : t('competition_edit.start_date')}
    </CompetitionEditPageGridLabel>
    {/* @ts-ignore */}
    <CompetitionEditPageGridStartLabel  isLMS={competition?.lmsModuleProjectId}>
      <CustomDateTimePicker
          value={startDate}
          className="date-input"
          calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
          clearIcon={null}
          format="dd-MM-yyyy HH:mm:ss"
          maxDate={new Date('9999-09-13T05:00')}
          locale={i18n.language}
          onChange={handleDateChange(setStartDate)}
          // @ts-ignore 
          isLMS={competition?.lmsModuleProjectId}
          onCalendarOpen={() => handlePickerOpen('start')}
          onCalendarClose={() => {
            handlePickerClose();
            handleBlur(setStartDate, startDate)();
          }}
      />
    </CompetitionEditPageGridStartLabel>
  </CompetitionEditPageGridRow>, [t, isMobile, startDate, minStartDate, i18n, setStartDate])

  const endDateInput = useMemo(() => <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('end') }}>
    {/* @ts-ignore */}
    <CompetitionEditPageGridLabel isLMS={competition?.lmsModuleProjectId}>
      <FlexBox direction="column" width={200}>
        {t('competition_edit.end_date')}
        <ExamMoscowTime>  {t('competition_edit.exam_moscow_time')}</ExamMoscowTime>
      </FlexBox>
    </CompetitionEditPageGridLabel>
    {/* @ts-ignore */}
    <CompetitionEditPageGridStartLabel isLMS={competition?.lmsModuleProjectId}>
      <CustomDateTimePicker
          value={endDate}
          className="date-input"
          calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
          clearIcon={null}
          format="dd-MM-yyyy HH:mm:ss"
          maxDate={new Date('9999-09-13T05:00')}
          locale={i18n.language}
          onChange={handleDateChange(setEndDate)}
          // @ts-ignore
          isLMS={competition?.lmsModuleProjectId}
          onCalendarOpen={() => handlePickerOpen('end')}
          onCalendarClose={() => {
            handlePickerClose();
            handleEndDateBlur(setEndDate, endDate)();
          }}
      />
    </CompetitionEditPageGridStartLabel>
  </CompetitionEditPageGridRow>, [t, isMobile, endDate, startDate, i18n, setEndDate, competition])

  const modersInput = useMemo(() => <ProjectAuthorsWrapper isCompetitionEdit isCompetitions={true} direction={"column"} directionMobile={"column"}>
    <ProjectAuthorsEdit
        isCompetitions={true}
        label={t('competition_edit.moders')}
        value={competitionModerators}
        onChange={onCompetitionModeratorsChange}
        isAdminPage
    />
  </ProjectAuthorsWrapper>, [t, competitionModerators, onCompetitionModeratorsChange])

  const administratorsInput = useMemo(() => <ProjectAuthorsWrapper isCompetitionEdit isCompetitions={true} direction={"column"} directionMobile={"column"}>
    <ProjectAuthorsEdit
        isCompetitions={true}
        label={t('competition_edit.admins')}
        value={competitionAdministrators}
        canRemoveUser={competitionAdministrators?.length === 1}
        onChange={onCompetitionAdministratorsChange}
        isAdminPage
        // @ts-ignore
        isLMS={competition?.lmsModuleProjectId}
    />
  </ProjectAuthorsWrapper>, [t, competitionAdministrators, onCompetitionAdministratorsChange])

  // @ts-ignore
  const juriesInput = useMemo(() => <ProjectAuthorsWrapper  isCompetitionEdit isLMS={competition?.lmsModuleProjectId} isCompetitions={true} direction={"column"} directionMobile={"column"}>
    <ProjectAuthorsEdit
        isCompetitions={true}
        label={t('competition_edit.juries')}
        value={competitionJury}
        onChange={onCompetitionJuryChange}
        isAdminPage
        // @ts-ignore
        isLMS={competition?.lmsModuleProjectId}
        //competition={competition}
        ignoreContext
    />
  </ProjectAuthorsWrapper>, [t, competitionJury, competition, onCompetitionJuryChange])

  const enrollButtonBlock = useMemo(() => {
    return (
      <CompetitionEditPageGridRow>
        <CommonInput 
          label={t('competition_edit.enroll_button_text')}
          type={INPUT_TYPES.textarea}
          value={enrollButtonText}
          maxLength={800}
          onChange={(value: any, currentLang?: string) => setEnrollButtonText(setTextByLang(enrollButtonText, currentLang ?? 'ru', value.target.value))}
        />
      </CompetitionEditPageGridRow>
    )

  }, [enrollButtonText])

  const paidApplicationInput = useMemo(() => (
    <CompetitionEditPageGridRow isCheckbox={true}>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.paid_application')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isCheckbox={true}>
        <Input.Checkbox
            className={'competition-checkbox'}
            checked={isPaidApplication}
            title={''}
            onChange={(value: any) => setIsPaidApplication(value.target.checked)}
        />
      </CompetitionEditPageGridInput>
    </CompetitionEditPageGridRow>
  ), [isPaidApplication, t])

  const certificatesBlock = useMemo(() => {
    if (competition && competition.status === 5) {
      return (
        <CompetitionEditPageGridRow largeOffsets align="flex-start">
          <CompetitionEditPageGridLabel>
            {t('competition_edit.certificates.certificates')}
          </CompetitionEditPageGridLabel>
          <CompetitionEditPageGridInput>
            <CompetitionCertificatesBlock competition={competition}/>
          </CompetitionEditPageGridInput>
        </CompetitionEditPageGridRow>
      )
    }
  }, [competition, t])

  const longReadBlock = useMemo(() => {
    return (
      // @ts-ignore
      <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, marginBottom: 24 }} isLMS={competition?.lmsModuleProjectId}>
         {/* @ts-ignore */}
         <CompetitionEditPageGridLabel isLMS={competition?.lmsModuleProjectId}>
          {t('competition_edit.description')}
        </CompetitionEditPageGridLabel>
        <LongReadBlock
            raw={competitionLongreads}
            longReadLength={longReadLength}
            setLongReadLength={setLongReadLength}
            // @ts-ignore
            isLMSExamEdit={!!competition?.lmsModuleProjectId}
            onSetMobTextLength={handleSetMobTextLengthChange}
            toggleMobileEditor={toggleMobileEditor}
            mobileEditorAction={mobileEditorAction}
          />
       
      </CompetitionEditPageGridRow>
    )
  }, [competitionLongreads, longReadLength, handleSetMobTextLengthChange, toggleMobileEditor, mobileEditorAction])

  const AllowParticipantBlock = useMemo(() => (
    <>
      <CompetitionFixedBlock isCheckbox={true}>
        <CompetitionEditPageGridLabel>
          {t('competition_edit.allow_participant')}
        </CompetitionEditPageGridLabel>
        <CompetitionEditPageGridInput isCheckbox={true}>
          <Input.Checkbox
              className={'competition-checkbox'}
              checked={allowEmptyParticipantRequests}
              title={''}
              disabled={isPreRegistration}
              onClick={(value: any) => {
                setAllowEmptyParticipantRequests(!allowEmptyParticipantRequests)
              }}
          />
        </CompetitionEditPageGridInput>
      </CompetitionFixedBlock>
    </>), [allowEmptyParticipantRequests, isPreRegistration, t])

  if (isUpdateError) {
    return <ProjectEditFrameUpdateError id={id}/>;
  }

  if (isForbidden) {
    return <ProjectEditFrameForbidden id={id}/>;
  }

  if (isError) {
    return <ProjectEditFrameError id={id}/>;
  }

  if (isCreating) {
    return <CompetitionEditFrameCreating id={id}/>;
  }

  if (!competition || !profile || !competition.competitionId) {
    return <CompetitionEditFrameLoading id={id}/>;
  }

  // @ts-ignore
  if (competition?.lmsModuleProjectId) {
    return <>
      {PortalMenu}
      <ExamPageEdit
        juriesInput={juriesInput}
        competitionStatusInput={competitionStatusInput}
        startDateInput={startDateInput}
        endDateInput={endDateInput} competitionExamNameInput={competitionExamNameInput}
        saveButton={submitButton}
        longReadBlock={longReadBlock}
        paidApplicationInput={paidApplicationInput}
        isModer={isModer}
    /></>;
  }

  const { theme: newTheme } = createThemeByColor(userColor, theme);

  const localized_sip = (!!competition?.isBilingual && i18n.language === 'en') ? sip_en : sip

  const AutoCheckboxes = <>
    <CompetitionFixedBlock isCheckbox={true}>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.automatic')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isCheckbox={true}>
        <Input.Checkbox
            className={'competition-checkbox'}
            checked={isAutomatic}
            title={''}
            onChange={(value: any) => setIsAutomatic(value.target.checked)}
        />
      </CompetitionEditPageGridInput>
    </CompetitionFixedBlock>

    {!isBriefModer && (
      <CompetitionFixedBlock isCheckbox={true}>
        <CompetitionEditPageGridLabel>
          {'isBriefCompetition'}
        </CompetitionEditPageGridLabel>
        <CompetitionEditPageGridInput isCheckbox={true}>
          <Input.Checkbox
              className={'competition-checkbox'}
              checked={isBriefCompetition}
              title={''}
              onChange={(value: any) => handleToggleBriefCompetitionClick(value.target.checked)}
          />
        </CompetitionEditPageGridInput>
      </CompetitionFixedBlock>
    )}

    <CompetitionFixedBlock isCheckbox={true} largeOffsets>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.visibility')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isCheckbox={true}>
        <Input.Checkbox
            className={'competition-checkbox'}
            checked={competitionVisibility}
            title={''}
            onChange={(value: any) => setCompetitionVisibility(value.target.checked)}
        />
      </CompetitionEditPageGridInput>
    </CompetitionFixedBlock>

    {isAutomatic && (
        <>
          <CompetitionFixedBlock isCheckbox={true}>
            <CompetitionEditPageGridLabel>
              {t('competition_edit.ignore_main')}
            </CompetitionEditPageGridLabel>
            <CompetitionEditPageGridInput isCheckbox={true}>
              <Input.Checkbox
                  className={'competition-checkbox'}
                  checked={competitionIgnoreProjectShowcase}
                  title={''}
                  onChange={(value: any) => setCompetitionIgnoreProjectShowcase(value.target.checked)}
              />
            </CompetitionEditPageGridInput>
          </CompetitionFixedBlock>
        </>)}
  </>

  const PreRegistrationBlock = (
    <>
      <CompetitionFixedBlock isCheckbox={true}>
        <CompetitionEditPageGridLabel>
          {t('competition_edit.pre_registration')}
        </CompetitionEditPageGridLabel>
        <CompetitionEditPageGridInput isCheckbox={true}>
          <Input.Checkbox
              className={'competition-checkbox'}
              checked={isPreRegistration}
              title={''}
              disabled={!(!competitionCreativeOpen && !allowEmptyParticipantRequests) || isBriefCompetition}
              onChange={(value: any) => setIsPreRegistration(value.target.checked)}
          />
        </CompetitionEditPageGridInput>
      </CompetitionFixedBlock>
    </>)

  const DocsBlock = <>
  <CompetitionFixedBlock isCheckbox={true}>
    <CompetitionEditPageGridLabel>
      {t('competition_edit.use_form')}
    </CompetitionEditPageGridLabel>
    <CompetitionEditPageGridInput isCheckbox={true}>
      <Input.Checkbox
          className={'competition-checkbox'}
          checked={competitionCreativeOpen}
          title={''}
          disabled={isPreRegistration}
          onChange={(value: any) => setCompetitionCreativeOpen(value.target.checked)}
      />
    </CompetitionEditPageGridInput>
  </CompetitionFixedBlock>
  </>;

  const FooterBlock = <CompetitionEditPageGrid>
    {PreRegistrationBlock}
    {AllowParticipantBlock}
    {DocsBlock}
    {AutoCheckboxes}

  <CompetitionFixedBlock>
    <ColorPicker
      isCompetition={true}
      value={userColor}
      onChange={(color) => setUserColor(color)}
    />
  </CompetitionFixedBlock>

  {isMobile && (
    <CompetitionEditPageGridRow>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.docs')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput>
        <Select
            placeholder={t('competition_edit.select')}
            isClearable
            isMulti
            className={'competition-select-input'}
            classNamePrefix={'competition-select'}
            options={competitionDocumentOptions}
            value={competitionDocuments}
            onChange={(item: any) => setCompetitionDocuments(item)}
        />
      </CompetitionEditPageGridInput>
    </CompetitionEditPageGridRow>
    )}


  <CompetitionFixedBlock offsetBottom={56}>
    <CompetitionEditPageGridLabel></CompetitionEditPageGridLabel>
    <BilingualSwitcher isBilingual={isBilingual} onClick={handleToggleBilingualClick} isCompetitionEdit/>
  </CompetitionFixedBlock>

        <FlexBox direction="column" directionMobile="column" offsetBottom={isMac13 ? 40 : 56} offsetBottomMobile={40}>
          <LangTitleBox title={t('competition_edit.labels.tags')} mainTitle={true} isCompetitionEdit />

          {requiredTagsInput}
          {regularTagsInput}
          {excludingTagsInput}

        </FlexBox>

    {criteriasBlock}
    <CompetitionEditPageGridRow style={{marginBottom: '24px'}} isCheckbox={true} largeOffsets>
     
      {tabsData.map((tab, index) => {
                
                if(tab.tabId === '1'){
                  const name = tab.name
                  return (
                    <>
                    <CommonInput 
                      type={INPUT_TYPES.text}
                        maxLength={25}
                        value={!!name ? name : ''}
                        placeholder={t(`competition.tabs.${CUSTOMTABS[tab.tabId]}`)}
                        label={t('competition_edit.show_about')}
                        //@ts-ignore
                        onChange={(ev, currentLang?: string) => onTabNameChange(ev?.target?.value, tab?.position, currentLang)}
                    />
                    </>
                );
                }
              })}
    </CompetitionEditPageGridRow>
  <LangTitleBox title={t('competition_edit.labels.jury')} mainTitle isCompetitionEdit />
  <CompetitionEditPageGridRow isCheckbox={true} largeOffsets>
  
      {tabsData.map((tab, index) => {
            
                if(tab.tabId === '2'){
                  const currentLang = tab?.currentLang || 'ru';
                  const name = Lang(tab.name, currentLang);             
                  return (
                    <>
                      <CompetitionEditPageGridLabel fullSize>
                        <LangTitleBox 
                          title={t('competition_edit.show_jury')} 
                          mainTitle={false} 
                          onLangChange={() => onLocalLangChanges(tabsData, currentLang, tab.tabId, (val) => setTabsData(val))} 
                          lang={currentLang} 
                          isCompetitionEdit
                          />
                      </CompetitionEditPageGridLabel>
                      <CompetitionEditPageGridInput isCheck isCheckbox={true}>
                          <Input.Checkbox
                              className={'competition-checkbox'}
                              checked={tab.enable}
                              title={''}
                              onChange={(value: any) => onTabCheckboxChange(value.target.checked, tab?.position)}
                          />
                      </CompetitionEditPageGridInput>
                      <CommonInput 
                        type={INPUT_TYPES.text}
                        maxLength={14}
                        value={!!name ? name : ''}
                        placeholder={t(`competition.tabs.${CUSTOMTABS[tab.tabId]}`)}
                        //@ts-ignore
                        onChange={(ev) => onTabNameChange(ev?.target?.value, tab?.position, currentLang)}
                      />
                    </>
                );
                }
              })}
    </CompetitionEditPageGridRow>
    {administratorsInput}
    {modersInput}
    {juriesInput}

    <CompetitionEditPageGridRow>
      <CommonInput 
        type={INPUT_TYPES.textarea}
        orientation="row"
        label={t('competition_edit.enter_text')}
        maxLength={800}
        value={Lang(competitionJuryText, i18n.language)}
        onChange={(value: any) => onCompetitionJuryTextChange(value.target.value)}
      />
    </CompetitionEditPageGridRow>
    <CompetitionEditPageGridRow>
      <CommonInput 
        type={INPUT_TYPES.text}
        orientation="row"
        value={competitionLink}
        label={t('competition_edit.link')}
        placeholder={t('create.title_info.link_format')}
        onChange={(value: any) => {
          setCompetitionLink(value.target.value)
        }}
      />
    </CompetitionEditPageGridRow>

    <CompetitionEditPageGridRow>
      <CommonInput 
        type={INPUT_TYPES.text}
        orientation="row"
        label={t('competition_edit.max_participants')}
        placeholder={t('create.title_info.participants_count')}
        value={maxParticipantsCount}
        onChange={({ target }: any) => {
          const reg = /[\D]/g;
          const val = target.value;
          if ((Number(val) === 0 && val !== '') || val.match(reg)) {
            toasts.error(t(`competition_edit.frames.wrong_symbols`))
            return;
          }
          if (!allowedMaxCount(Number(val), MAX_PARTICIPANTS_COUNT)) {
            toasts.error(t(`competition_edit.frames.max_participants`, { count: MAX_PARTICIPANTS_COUNT }))
            return;
          }

          setMaxParticipantsCount(val)
        }}
      />
    </CompetitionEditPageGridRow>
    {isBriefCompetition && (
      <CompetitionEditPageGridRow>
        <CommonInput 
          type={INPUT_TYPES.dropdown}
          orientation="row"
          label={t('competition_edit.flow_number')}
          value={briefCompetitionFlow}
          options={fabricFlowOpts.map(item => ({...item, label: t(`competition_edit.designFabricForm.flows.label.${item.label}`)}))}
          onChange={(item: any) => setBriefCompetitionFlow(item)}
        />
      </CompetitionEditPageGridRow>
    )}

<FlexBox direction="column" directionMobile="column" offsetTop={isMac13 ? 40 : 56} offsetTopMobile={40}>
    <LangTitleBox title={t('competition_edit.labels.winners')} mainTitle isCompetitionEdit />                        
    <CompetitionEditPageGridRow isCheckbox={true} largeOffsets>
    
      {tabsData.map((tab, index) => {
                if(tab.tabId === '3'){
                  const currentLang = tab?.currentLang || 'ru';
                  const name = Lang(tab.name, currentLang);
                  
                  return (
                    <>
                    <CompetitionEditPageGridLabel fullSize>
                      <LangTitleBox 
                        title={t('competition_edit.show_all_projects')} 
                        mainTitle={false} 
                        onLangChange={() => onLocalLangChanges(tabsData, currentLang, tab.tabId, (val) => setTabsData(val))} 
                        lang={currentLang} 
                        isCompetitionEdit
                                  />
                    </CompetitionEditPageGridLabel>
                    <CompetitionEditPageGridInput isCheck isCheckbox={true}>
                                    <Input.Checkbox
                                        className={'competition-checkbox'}
                                        checked={tab.enable}
                                        title={''}
                                        onChange={(value: any) => onTabCheckboxChange(value.target.checked, tab?.position)}
                                    />
                    </CompetitionEditPageGridInput>
                    <CommonInput 
                      type={INPUT_TYPES.text}
                      maxLength={14}
                      value={!!name ? name : ''}
                      placeholder={t(`competition.tabs.${CUSTOMTABS[tab.tabId]}`)}
                      //@ts-ignore
                      onChange={(ev) => onTabNameChange(ev?.target?.value, tab?.position, currentLang)}
                    /> 
                  </>
                );
                }
              })}
    </CompetitionEditPageGridRow>
    <CompetitionEditPageGridRow isCheckbox={true} largeOffsets>
      
      {tabsData.map((tab, index) => {
                if(tab.tabId === '4'){
                  const currentLang = tab?.currentLang || 'ru';
                  const name = Lang(tab.name, currentLang);
                  return (
                    <>
                    <CompetitionEditPageGridLabel fullSize>
                      <LangTitleBox 
                        title={t('competition_edit.show_short_list')} 
                        mainTitle={false} 
                        onLangChange={() => onLocalLangChanges(tabsData, currentLang, tab.tabId, (val) => setTabsData(val))} 
                        lang={currentLang} 
                        isCompetitionEdit
                        />
                    </CompetitionEditPageGridLabel>
                     <CompetitionEditPageGridInput isCheck isCheckbox={true}>
                     <Input.Checkbox
                        className={'competition-checkbox'}
                        checked={showShortList}
                        title={''}
                        onChange={(value: any) => {
                          onTabCheckboxChange(value.target.checked, tab?.position)
                          setShowShortList(value.target.checked)
                        }}
                       />
                      </CompetitionEditPageGridInput>
                      <CommonInput 
                        type={INPUT_TYPES.text}
                        maxLength={14}
                        value={!!name ? name : ''}
                        placeholder={t(`competition.tabs.${CUSTOMTABS[tab.tabId]}`)}
                        //@ts-ignore
                        onChange={(ev) => onTabNameChange(ev?.target?.value, tab?.position, currentLang)}
                      />
                    </>
                );
                }
              })}
    </CompetitionEditPageGridRow>

    {winnerTextBlock}

    <CompetitionEditPageGridRow largeOffsets align={!winnerPositions?.length ? 'center' : "start"}  alignMobile={!winnerPositions?.length ? 'center' : "start"} style={{ alignItems: !isMobile ? (!winnerPositions?.length ? 'center' : "start") : 'start'}} isWinners>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.winners')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isChoose={true}>
        <ShortListWinnerProjectsEdit
            competitionId={competition.competitionId}
            projects={winnerPositions}
            onSetProjects={onSetWinnerPostitions}
            onRebuildProjects={rebuildWinnerPositions}
            onSort={onSortWinners}
            onSetPosition={onSetWinnerPosition}
            draggable={!is744BP}
            >
        </ShortListWinnerProjectsEdit>
      </CompetitionEditPageGridInput>
    </CompetitionEditPageGridRow>

    {winnerFinalTextBlock}
    {enrollButtonBlock}

    <CompetitionEditPageGridRow offsetBottomMobile={!finalistsID?.length ? 16 : 0} isChoose={true} largeOffsets align={!finalistsID?.length ? 'center' : "start"} alignMobile={!finalistsID?.length ? 'center' : "start"} style={{ alignItems: !isMobile ? (!finalistsID?.length ? 'center' : "start") : 'start' }}>
      <CompetitionEditPageGridLabel>
        {t('competition_edit.finalists')}
      </CompetitionEditPageGridLabel>
      <CompetitionEditPageGridInput isChoose={true}>
        <ShortListProjectsEdit
            competitionId={competition.competitionId}
            projectIds={finalistsID}
            draggable={!is744BP}
            onSetProjects={(data: any) => setFinalistsID(data?.reverse())}>
        </ShortListProjectsEdit>
      </CompetitionEditPageGridInput>
    </CompetitionEditPageGridRow>

    {certificatesBlock}

    </FlexBox>
  </CompetitionEditPageGrid>

  

  return (
    <ThemeProvider theme={newTheme as any}>
      <CustomBgWrapper backgroundColor={userColor}>
        <GlobalColoring color={userColor} brighter={brighter} darker={darker}/>
        <PageViewportLayout vtype={vtype} style={{ marginTop: is744BP ? 10 : isMobile ? 0 : 14 }}>
          {PortalMenu}

          <ProjectContainerLayout
              isCompetitionEdit={true}
            leftSide={
              <LeftSide
                isCompetitionEdit={true}
                project={competitionTitleImages}
                customProps={custom}
                userColor={userColor}
                // @ts-ignore
                fileInput={localized_sip}
              />
            }
            rightSide={(
              <CompetitionEditPageContainer>
                <ProjectTitleSection
                  isCompetitionEdit={true}
                  customProps={custom}
                  projectTitle={Lang(competitionName, i18n.language)}
                  setProjectTitle={onCompetitionNameChange}
                />

                <CompetitionEditPageGridRow direction="column" >
                  <FlexBox direction={'row'} width={'100%'} gx={8}>
                    <CommonInput
                      type={INPUT_TYPES.text}
                      orientation="row"
                      label={t('competition_edit.context')}
                      value={competitionContextText}
                      onChange={(ev: any) => allowedCharacters(ev, setCompetitionContextText)}
                      // resultComponent={
                      //   <ContextsSection value={competitionContexts} onClick={onDeleteContext} />
                      // }
                    />
                    {!!competitionContextText?.length && (
                      <FlexBox>
                      <DefaultButton wh={50} whMob={50} onClick={() => {
                        if (!competitionContexts.includes(competitionContextText)) {
                          setCompetitionContexts([...competitionContexts, competitionContextText]);
                          if (competitionContextText === COMPETITIONS_CONTEXTS.briefs) {
                            setIsBriefCompetition(true);
                          }
                        }
                        setCompetitionContextText('');
                      }}>+</DefaultButton>

                      </FlexBox>
                    )}
                  </FlexBox>    
                    <ContextsSection value={competitionContexts} onClick={onDeleteContext} />
                </CompetitionEditPageGridRow>

                <CompetitionEditPageGridRow direction="column" >
                  <CommonInput
                    type={INPUT_TYPES.dropdown}
                    label={t('competition_edit.status')}
                    options={STATUSES_List.map(item => ({...item, label: t('competition.statuses.'+item.label)})) as any}
                    value={competitionStatus as any}
                    onChange={(item: any) => setCompetitionStatus(item)}
                  />
                </CompetitionEditPageGridRow>


                <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('start') }}>
                  <CompetitionEditPageGridLabel>
                    {t('competition_edit.start_date')}
                    <LabelRedStar>*</LabelRedStar>
                  </CompetitionEditPageGridLabel>
                  <CompetitionEditPageGridStartLabel>
                    <CustomDateTimePicker
                        value={startDate}
                        className="date-input"
                        calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
                        clearIcon={<CloseIconSmall />}
                        format="dd-MM-yyyy HH:mm:ss"
                        maxDate={new Date('9999-09-13T05:00')}
                        locale={i18n.language}
                        onChange={handleDateChange(setStartDate)}
                        onCalendarOpen={() => handlePickerOpen('start')}
                        onCalendarClose={() => {
                          handlePickerClose();
                          handleCompetitionBlur(setStartDate, startDate)();
                        }}
                        disableClock={true}
                        
                    />
                  </CompetitionEditPageGridStartLabel>
                </CompetitionEditPageGridRow>

                <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('tech') }}>
                  <CompetitionEditPageGridLabel>
                    {t('competition_edit.end_date_tech')}
                    <LabelRedStar>*</LabelRedStar>
                  </CompetitionEditPageGridLabel>
                  <CompetitionEditPageGridStartLabel>
                    <CustomDateTimePicker
                        value={endDate_Internal}
                        className="date-input"
                        calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
                        clearIcon={<CloseIconSmall />}
                        format="dd-MM-yyyy HH:mm:ss"
                        maxDate={new Date('9999-09-13T05:00')}
                        locale={i18n.language}
                        onChange={handleDateChange(setEndDate_Internal)}
                        onCalendarOpen={() => handlePickerOpen('tech')}
                        onCalendarClose={() => {
                          handlePickerClose();
                          handleEndDateBlur(setEndDate_Internal, endDate_Internal)();
                        }}
                        disableClock={true}
                    />
                  </CompetitionEditPageGridStartLabel>
                </CompetitionEditPageGridRow>

                <CompetitionEditPageGridRow largeOffset={isMobile} style={{ marginTop: isMobile ? 32 : 0, zIndex: getZIndex('end') }}>
                  <CompetitionEditPageGridLabel>
                    {t('competition_edit.end_date')}
                    <LabelRedStar>*</LabelRedStar>
                  </CompetitionEditPageGridLabel>
                  <CompetitionEditPageGridStartLabel>
                    <CustomDateTimePicker
                        value={endDate}
                        className="date-input"
                        calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
                        clearIcon={<CloseIconSmall />}
                        format="dd-MM-yyyy HH:mm:ss"
                        maxDate={new Date('9999-09-13T05:00')}
                        locale={i18n.language}
                        onChange={handleDateChange(setEndDate)}
                        onCalendarOpen={() => handlePickerOpen('end')}
                        onCalendarClose={() => {
                          handlePickerClose();
                          handleEndDateBlur(setEndDate, endDate)();
                        }}
                        disableClock={true}
                        
                    />
                  </CompetitionEditPageGridStartLabel>
                </CompetitionEditPageGridRow>
               
                  {!isMobile && (
                    <CompetitionEditPageGridRow>
                     <CompetitionEditPageGridLabel>
                       {t('competition_edit.docs')}
                     </CompetitionEditPageGridLabel>
                     <CompetitionEditPageGridInput>
                        <Select
                            placeholder={t('competition_edit.select')}
                            isClearable
                            isMulti
                            className={'competition-select-input'}
                            classNamePrefix={'competition-select'}
                            options={competitionDocumentOptions}
                            value={competitionDocuments}
                            onChange={(item: any) => setCompetitionDocuments(item)}
                        />
                      </CompetitionEditPageGridInput>
                    </CompetitionEditPageGridRow>
                  )}
                  {isRating && (
                    <CommonInput 
                      type={INPUT_TYPES.text}
                      value={editContextText}
                      disable
                      label={t('competition_edit.project_context')}
                      onChange={(ev: any) => setEditContextText(ev.target.value)}
                    />
                  )}


                {is744BP && FooterBlock}

                {is744BP && (
                    <LongReadBlock
                        raw={competitionLongreads}
                        longReadLength={longReadLength}
                        setLongReadLength={setLongReadLength}
                    />
                )}

              </CompetitionEditPageContainer>
            )}
            footer={!is744BP ? FooterBlock : undefined}
          />

          {!is744BP && (
            <LongReadBlock
              raw={competitionLongreads}
              longReadLength={longReadLength}
              setLongReadLength={setLongReadLength}
            />
          )}

          <FlexBox offsetTop={200} offsetTopMobile={40} />
        </PageViewportLayout>
      </CustomBgWrapper>
      <ScrollUpZone/>
    </ThemeProvider>
  );
}

export default CreateCompetitionPage;